// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:36.065Z
// Property: Aspen Park Apartments (ID: 6767906449166543)
// Collections: 21 amenities, 5 floorplans (live), 32 photos, 68 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166543",
  "property_external_id": "781299",
  "property_zillow_url": "https://www.zillow.com/apartments/wichita-ks/aspen-park-apartments/5Xt4Cw/",
  "property_apartments_url": "https://www.apartments.com/aspen-park-apartments-wichita-ks/cn6pf9g/",
  "property_google_business_url": "https://www.google.com/maps/place/Aspen+Park+Apartments/data=!4m2!3m1!1s0x0:0x7ccb6e5c66307835?sa=X&ved=2ahUKEwiBv_vUg72SAxXEVTABHcv8LRwQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "aspen-park-apartments",
  "property_name": "Aspen Park Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/aspen-park/",
  "property_domain": null,
  "property_address": "8405 West Central Avenue",
  "property_full_address": "8405 W Central Ave, Wichita, KS 67212, USA",
  "property_address_1": "8405 West Central Avenue",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67212",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": "West Wichita",
  "property_address_latitude": "37.6936",
  "property_address_longitude": "-97.4407",
  "property_email": "aspenpark@caseusa.com",
  "property_phone": "(316) 323-1550",
  "property_call_tracking_phone": "844-493-0494",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Aspen Park in Wichita, KS, where modern living meets comfort. Choose from spacious studio, one, or two-bedroom apartments equipped with premium amenities like a refreshing pool, fitness center, and serene courtyards. Elevate your lifestyle—view our floor plans and schedule a tour to experience it all firsthand! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Aspen Park, your premier apartment community in Wichita, KS, offering a perfect blend of comfort, convenience, and style. Choose from a variety of thoughtfully designed floor plans, including cozy studios, spacious one bedrooms, and luxurious two-bedroom apartments, perfectly tailored to fit your lifestyle.\n\nAt Aspen Park, we prioritize your well-being with an array of outstanding amenities. Enjoy sunny days by our inviting pool, stay active in our state-of-the-art fitness center, or unwind in our beautifully landscaped courtyard. For your convenience, we provide laundry facilities, an on-site maintenance team, and a property manager readily available to address your needs. Our business center is equipped for your professional requirements, while our clubhouse serves as a perfect gathering spot for friends and neighbors.\n\nExperience outdoor leisure with our tennis court, sundeck, and picnic area complete with grills—ideal for hosting summer barbecues with family and friends. Each apartment features modern conveniences such as air conditioning, high-speed internet access, and spacious walk-in closets, ensuring your new home is both comfortable and functional. Enjoy additional perks like a cozy fireplace, private balcony or patio, and efficient kitchen with a dishwasher for effortless clean-up.\n\nEnsure a smoke-free environment while relishing the positive vibes of community living at Aspen Park. Don’t miss the opportunity to elevate your lifestyle in Wichita; find your new home today—browse our availability or schedule a tour to visit our vibrant community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4d-fa13-74be-92ae-ea1e63737115.webp",
  "property_featured_image_media": {
    "alt_text": "Aspen Park Apartments monument sign with landscaping and fence",
    "public_id": "019cfb4d-fa13-74be-92ae-ea1e63737115",
    "storage_key": "property/6767906449166543/019cfb4d-fa13-74be-92ae-ea1e63737115.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "384",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.39583333333334",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "250",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets per unit, with a maximum weight of 80 lb each.",
  "property_pet_policy_description": "We welcome cats and dogs up to 80 lb. Pet fee: half of one month’s rent per pet. Monthly pet rent: $30. Maximum 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://aspenparkapartmentswichita.securecafe.com/onlineleasing/aspen-park-apartments-0/floorplans.aspx",
  "property_resident_portal_url": "https://aspenparkapartmentswichita.securecafe.com/residentservices/aspen-park-apartments-0/userlogin.aspx",
  "property_apply_now_url": "https://aspenparkapartmentswichita.securecafe.com/onlineleasing/aspen-park-apartments-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4135-760c-8541-4cb015ae577b.webp",
  "property_primary_logo_media": {
    "alt_text": "Aspen Park Apartments logo",
    "public_id": "019cfb4e-4135-760c-8541-4cb015ae577b",
    "storage_key": "property/6767906449166543/019cfb4e-4135-760c-8541-4cb015ae577b.webp",
    "width": 2509,
    "height": 939
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4135-760c-8541-4cb015ae577b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Aspen Park Apartments logo",
    "public_id": "019cfb4e-4135-760c-8541-4cb015ae577b",
    "storage_key": "property/6767906449166543/019cfb4e-4135-760c-8541-4cb015ae577b.webp",
    "width": 2509,
    "height": 939
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4f-9770-703a-83af-d4f40d4901dc.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Aspen Park Apartments logo with a leaf icon",
    "public_id": "019cfb4f-9770-703a-83af-d4f40d4901dc",
    "storage_key": "property/6767906449166543/019cfb4f-9770-703a-83af-d4f40d4901dc.webp",
    "width": 640,
    "height": 240
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4f-a04e-7041-aade-e721cb04be1f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Aspen Park Apartments logo",
    "public_id": "019cfb4f-a04e-7041-aade-e721cb04be1f",
    "storage_key": "property/6767906449166543/019cfb4f-a04e-7041-aade-e721cb04be1f.webp",
    "width": 640,
    "height": 240
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#295044",
  "property_secondary_color": "#cac4b8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "500 - 900",
  "property_sqft_min": "500",
  "property_sqft_max": "900",
  "property_price_range": "769 - 1019",
  "property_price_min": "769",
  "property_price_max": "1019",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/aspenparkapartmentswichita/",
  "property_instagram_url": "https://www.instagram.com/aspenparkapartmentswichita/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJIXoVF8XfuocRNXgwZlxuy3w",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/aspen-park-apartments-wichita-2",
  "property_tiktok_url": "https://www.tiktok.com/@aspenparkapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Aspen Park",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Aspen Park in Wichita, KS, where modern living meets comfort. Choose from thoughtfully designed studios to spacious two-bedroom apartments, each featuring generous amenities like a resort-style pool, fitness center, and inviting clubhouse. Embrace outdoor relaxation on our sun-soaked patio or grill in the picturesque picnic area.",
  "property_home_floorplans_blurb": "At Aspen Park in Wichita, KS, find the ideal space for your lifestyle. Our thoughtfully designed studio, one-bedroom, and two-bedroom apartments offer a blend of comfort and style. Browse our available homes today and uncover the perfect floor plan tailored just for you. Your new beginning awaits!",
  "property_home_gallery_blurb": "Welcome to Aspen Park, where modern design meets community charm in Wichita, KS. Choose from diverse floor plans—including studio, one, and two-bedroom options. Enjoy unparalleled amenities like a refreshing pool, fitness center, and picturesque picnic areas. Picture yourself living here and embracing a lifestyle of comfort and convenience!",
  "property_home_neighborhood_blurb": "At Aspen Park in Wichita, KS, your home extends beyond your front door. Immerse yourself in the vibrant community, rich with cultural gems like the Wichita Art Museum and Exploration Place. With nearby parks, universities, and the Sedgwick County Zoo, adventure and learning are just steps away. ",
  "property_home_reviews_blurb": "At Aspen Park in Wichita, KS, residents rave about the community spirit and exceptional management. One delighted tenant states, “The staff takes their time to get to know you as a person, not just an apartment number.” Enjoy well-maintained amenities, diverse neighbors, and a cozy atmosphere all around!",
  "property_neighborhood_blurb": "At Aspen Park in Wichita, adventure awaits just beyond your doorstep. Immerse yourself in culture at the Wichita Art Museum, explore the wonders of Exploration Place, or enjoy the serenity of Botanica, The Wichita Gardens. With top-notch amenities and vibrant local attractions, your ideal lifestyle starts here!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Aspen Park in Wichita, KS, where modern living meets leisure. Our thoughtfully designed studios and spacious two-bedroom apartments come with pools, a fitness center, and inviting courtyards. Enjoy sun-soaked afternoons on your private balcony or a friendly match on the tennis court. Dive into community life today!",
  "property_applynow_blurb": "At Aspen Park in Wichita, KS, choose from spacious studio, one, and two-bedroom floor plans that cater to your lifestyle. Enjoy a resort-style living experience with amenities like a shimmering pool, fitness center, and inviting clubhouse. Ready to elevate your lifestyle? Lease your new home online today!",
  "property_contactus_blurb": "At Aspen Park in Wichita, KS, we offer a variety of thoughtfully designed floor plans, including cozy studios and spacious one and two-bedroom apartments. Each layout maximizes comfort and style, perfect for your lifestyle. Have questions? Our leasing team is ready to assist you today!",
  "property_faqs_blurb": "At Aspen Park in Wichita, KS, our diverse floor plans—from cozy studios to spacious two-bedroom apartments—cater to your unique lifestyle. Got questions? Our FAQs page offers insights on community living, ensuring you feel right at home. Browse now to uncover the answers you seek about your future apartment!",
  "property_floorplans_blurb": "At Aspen Park in Wichita, KS, your ideal home awaits among our thoughtfully designed floor plans. From cozy studios to spacious two-bedroom apartments, each layout is crafted for modern living. Browse our available apartment homes and find the perfect space that reflects your lifestyle and inspires comfort.",
  "property_gallery_blurb": "At Aspen Park in Wichita, KS, your dream lifestyle awaits. With various floor plans to suit your needs and amenities like a stunning pool, fitness center, and inviting clubhouse, every moment feels special. Picture yourself relaxing on your balcony or enjoying the picnic area—home is just a click away!",
  "property_interactivemap_blurb": "At Aspen Park in Wichita, KS, each apartment—whether a studio, one-bedroom, or two-bedroom—offers unique comfort. Enjoy amenities like a refreshing pool, state-of-the-art fitness center, and serene sundeck. Uncover your perfect living space with our interactive community map to easily find pricing and availability today!",
  "property_pets_blurb": "Nestled in vibrant Wichita, Aspen Park invites you to share your home with furry companions. With room for two pets, each up to 80 lbs, our community ensures your four-legged friends enjoy life as much as you do. Experience comfortable living paired with pet-friendly amenities at Aspen Park!",
  "property_referafriend_blurb": "At Aspen Park in Wichita, KS, our vibrant community offers studio, one-bedroom, and two-bedroom floor plans tailored for every lifestyle. Transform your living experience with neighbors who feel like family. Great friends make great neighbors—refer a friend today and share the joy of calling Aspen Park home!",
  "property_residentaccess_blurb": "Welcome to Aspen Park in Wichita, KS, where your perfect home awaits! Choose from stylish studio, one-bedroom, or spacious two-bedroom floor plans tailored for your lifestyle. Access your resident portal today to effortlessly pay rent, schedule maintenance, and enjoy a seamless living experience in our vibrant community!",
  "property_reviews_blurb": "At Aspen Park in Wichita, KS, residents truly thrive! Experience a welcoming community where the dedicated staff knows you by name and ensures your comfort. “The staff actually takes their time to get to know you as a person,” says one happy resident. Enjoy upgraded amenities and a supportive atmosphere every day! ",
  "property_created_at": "1759850765894",
  "property_scheduletour_blurb": "At Aspen Park in Wichita, KS, your perfect home awaits! Choose from stylish studio, one-bedroom, or two-bedroom floor plans designed for comfort and modern living. Ready to envision your new lifestyle? Schedule a tour and hear firsthand from our residents why they love calling Aspen Park home!",
  "property_thankyou_blurb": "Thank you for your interest in Aspen Park, where comfort meets style in Wichita, KS. Whether you’re seeking a cozy studio or a spacious two-bedroom apartment, we have the perfect floor plan to fit your lifestyle. A team member will reach out to you soon to discuss your new home!",
  "property_virtualtours_blurb": "At Aspen Park in Wichita, KS, your perfect living space awaits! From cozy studios to spacious two-bedroom apartments, each floor plan reflects modern comfort and style. Embrace the inviting community atmosphere. Ready to envision your new home? Take a virtual tour today and step into the lifestyle you deserve!",
  "property_copyright": "2025 All Rights Reserved. Aspen Park",
  "property_seo_title_home": "Aspen Park |  Apartments in Wichita, KS",
  "property_seo_description_home": "Experience luxury at Aspen Park, Wichita! Choose from stylish studios to spacious two-bedrooms with amenities like a pool and fitness center!",
  "property_seo_title_floorplans": "Floor Plans | Wichita, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Aspen Park in Wichita, KS! Browse our studio, one-bedroom, and two-bedroom floor plans to match your lifestyle today!",
  "property_seo_title_amenities": "Amenities | Wichita, KS Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at Aspen Park, Wichita, KS! Enjoy a resort-style pool, fitness center, and spacious layouts. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, KS",
  "property_seo_description_gallery": "Capture your dream home at Aspen Park in Wichita, KS. From stunning courtyards to cozy studios, see the amenities where comfort and style meet!",
  "property_seo_title_virtualtours": "Virtual Tours | Aspen Park Apartments",
  "property_seo_description_virtualtours": "Immerse yourself in Aspen Park, Wichita's inviting community. Take a virtual tour of our spacious studio, one, and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Aspen Park Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Aspen Park in Wichita, KS! Use our interactive map to explore studio to two-bedroom apartments with amazing amenities and pricing.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, KS",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Aspen Park in Wichita, KS. From local favorites to hidden gems, there's always something to explore nearby!",
  "property_seo_title_contact": "Contact Us | Aspen Park",
  "property_seo_description_contact": "Connect with Aspen Park in Wichita, KS! Explore our studio, one, and two-bedroom apartments. Questions? Our leasing team is here to help—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, KS",
  "property_seo_description_faqs": "Get answers to your top queries about Aspen Park in Wichita, KS. From our floor plans to amenities like a pool and fitness center, we have you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, KS",
  "property_seo_description_reviews": "Join the Aspen Park community in Wichita, KS! Read resident reviews and find out why our studios, 1 & 2-bedroom apartments feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, KS",
  "property_seo_description_applynow": "Unlock your ideal lifestyle at Aspen Park in Wichita, KS. With studios to two-bedroom apartments and luxurious amenities, your dream home awaits. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Aspen Park",
  "property_seo_description_residentaccess": "Log in to your Aspen Park portal for easy rent payments, maintenance requests, and community updates in Wichita, KS. Enjoy hassle-free living!",
  "property_seo_title_referafriend": "Refer A Friend | Aspen Park",
  "property_seo_description_referafriend": "Refer a friend to Aspen Park in Wichita, KS! Great friendships flourish here—help them find their perfect home among our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Aspen Park",
  "property_seo_description_scheduletour": "Experience the charm of Aspen Park in Wichita, KS. Book your tour today and imagine your new life in this vibrant apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Aspen Park",
  "property_seo_description_privacy": "Your privacy matters at Aspen Park. Review our commitment to your data security and how we protect your information while you enjoy life in Wichita, KS.",
  "property_seo_title_accessibility": "Website Accessibility | Aspen Park",
  "property_seo_description_accessibility": "Aspen Park in Wichita, KS, champions digital inclusion with accessibility features, ensuring everyone feels at home in our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | Aspen Park",
  "property_seo_description_sitemap": "Navigate your way to your new home at Aspen Park, Wichita, KS! Check out our sitemap for easy access to all community features and amenities.",
  "property_seo_title_thankyou": "Thank You | Aspen Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Aspen Park in Wichita, KS! Our team is excited to connect and help you find your perfect home. Stay tuned for our response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864786088",
  "amenities": [
    {
      "id": "ec_5a951c3b98104ec6a5a48edd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396225",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc50e258396dad0f4e58c5ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396226",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ce0ec52c05f6c45f0f41392",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396227",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f674758f4ce1bcaa57b48307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396229",
      "title": "Tennis Court and Pickle Ball Courts",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_172af47e8a8c1300a0c155f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396230",
      "title": "Fitness Center with Cardio Equipment and Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4533a2f4f3cd92639c72439e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396231",
      "title": "Outdoor Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70e35887118b14b0918e9178",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396232",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_819db6f530a11bf2c77297c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396233",
      "title": "Club House",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52230af090fa7085d3019292",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396234",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3a804d085549dea323782d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396235",
      "title": "Professional Maintenance Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35a7827bfdd9a83e6d2ac0c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396236",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbce6b7ee9ed68b9569ffea0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127396237",
      "title": "Close to I-35, I-135, I-235, K-96, and Kellogg",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f86a891823926cf109c9e8f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397733",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6b4cdecffb9cc66595e5edc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397734",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc20c7515f38d8748c7dc55b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397735",
      "title": "Roommate Split Floor Plan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79edca629d30f2a1a263e5cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397736",
      "title": "Patio / Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d77dc44e970e199567465e45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397737",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f995debe0d15c74c2f26f704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397738",
      "title": "Get Connected To Super-Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87edc8a7950a2ee4d40c7b3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397740",
      "title": "Ceiling Fan*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_751f961dc568bccdac6a4d5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397741",
      "title": "Fully Equipped Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e30860c5821937f7c0b86664",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "yardi",
      "external_id": "127397742",
      "title": "Upgraded Interiors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a60de49e-4042-471f-b7cf-b8792e2f0c69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db58a-169d-740b-8553-3d18b22355ee.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a walkway and grass.",
        "public_id": "019db58a-169d-740b-8553-3d18b22355ee",
        "storage_key": "property/6767906449166543/019db58a-169d-740b-8553-3d18b22355ee.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Walkway between apartment buildings featuring manicured lawns and exterior views.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a walkway and grass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52109a49-02e1-4272-af08-7d0a0270b2dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db58a-13e2-740f-ae06-04c22e7113e7.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with green lawns and walkways.",
        "public_id": "019db58a-13e2-740f-ae06-04c22e7113e7",
        "storage_key": "property/6767906449166543/019db58a-13e2-740f-ae06-04c22e7113e7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings, showcasing the community's well-maintained grounds with lush green lawns and paved walkways.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with green lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74b7b6cf-522a-4571-9bbe-f1768205b2fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db58a-006e-741d-be84-64cd5389e5e9.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with manicured lawn and picnic tables.",
        "public_id": "019db58a-006e-741d-be84-64cd5389e5e9",
        "storage_key": "property/6767906449166543/019db58a-006e-741d-be84-64cd5389e5e9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with picnic areas, offering a welcoming exterior view of the apartment community.",
      "link": "",
      "alt_text": "Exterior of apartment building with manicured lawn and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e89f1606-9b10-4625-bc88-8652aa8f07bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-ee21-769c-8d93-1b569ab8b7f2.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, a closet, and a bathroom.",
        "public_id": "019db589-ee21-769c-8d93-1b569ab8b7f2",
        "storage_key": "property/6767906449166543/019db589-ee21-769c-8d93-1b569ab8b7f2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, ample closet space, and convenient access to a bathroom. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, a closet, and a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85acd451-f736-4fe8-b254-dec40a331b20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-ebf0-76e7-af03-c1297242af2b.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a queen-size bed with light blue bedding, plush pillows, and a wooden headboard. A nightstand with a modern lamp sits to the left, and decorative starbursts adorn the wall.",
        "public_id": "019db589-ebf0-76e7-af03-c1297242af2b",
        "storage_key": "property/6767906449166543/019db589-ebf0-76e7-af03-c1297242af2b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, complete with a queen-size bed, elegant decor, and ample natural light. A perfect retreat after a long day.",
      "link": "",
      "alt_text": "A cozy bedroom featuring a queen-size bed with light blue bedding, plush pillows, and a wooden headboard. A nightstand with a modern lamp sits to the left, and decorative starbursts adorn the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21a7efdc-4192-4cb8-975e-4c47517e7e3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-d73a-71a3-aa95-674554faf1ef.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, white countertops, stainless steel sink, coffee maker, and white appliances.",
        "public_id": "019db589-d73a-71a3-aa95-674554faf1ef",
        "storage_key": "property/6767906449166543/019db589-d73a-71a3-aa95-674554faf1ef.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A functional kitchen featuring dark wood cabinets, white countertops, a stainless steel sink, a coffee maker, and a full-size refrigerator and stove.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, white countertops, stainless steel sink, coffee maker, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a351a594-0a62-4215-978a-dde8cc6c97eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-e2c8-77df-8b4d-68ea01415df7.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, plush bedding, and decorative pillows.",
        "public_id": "019db589-e2c8-77df-8b4d-68ea01415df7",
        "storage_key": "property/6767906449166543/019db589-e2c8-77df-8b4d-68ea01415df7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed with soft, inviting linens and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, plush bedding, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c4a8b670-a4e0-42c2-a2e2-5a1743c7fcbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-ddfe-7247-a453-0028d4f9f296.webp",
      "image_media": {
        "alt_text": "Updated bathroom with toilet, bathtub, shower, vanity, and sink.",
        "public_id": "019db589-ddfe-7247-a453-0028d4f9f296",
        "storage_key": "property/6767906449166543/019db589-ddfe-7247-a453-0028d4f9f296.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Renovated bathroom featuring a toilet, bathtub with shower, and a single vanity with sink, updated finishes, and ample storage.",
      "link": "",
      "alt_text": "Updated bathroom with toilet, bathtub, shower, vanity, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f890153-5cea-4cfb-aebd-e8ce4bec6eec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-da0e-73dd-ae84-fee94d36eb37.webp",
      "image_media": {
        "alt_text": "Empty closet with shelf and rod.",
        "public_id": "019db589-da0e-73dd-ae84-fee94d36eb37",
        "storage_key": "property/6767906449166543/019db589-da0e-73dd-ae84-fee94d36eb37.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Ample closet space for your storage needs.",
      "link": "",
      "alt_text": "Empty closet with shelf and rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_541faec9-41cd-4dec-adcf-6e931f638313",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-d66f-744c-b24c-f1281c2386cc.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, stove, and cabinets.",
        "public_id": "019db589-d66f-744c-b24c-f1281c2386cc",
        "storage_key": "property/6767906449166543/019db589-d66f-744c-b24c-f1281c2386cc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a refrigerator, stove, and ample cabinet space. Decorated with floral art on the wall.",
      "link": "",
      "alt_text": "Kitchen with white refrigerator, stove, and cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed7e68dc-0510-44a0-9c04-405e43a6cc10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-d072-74e9-9db4-c14ec88ee51e.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen view with table, chairs, and cabinets",
        "public_id": "019db589-d072-74e9-9db4-c14ec88ee51e",
        "storage_key": "property/6767906449166543/019db589-d072-74e9-9db4-c14ec88ee51e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy dining area adjacent to the kitchen, featuring a round table with four chairs, and ample cabinet space for storage.",
      "link": "",
      "alt_text": "Dining area and kitchen view with table, chairs, and cabinets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b9749c7-4f9e-4ff9-9bd9-4aba91f6480f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-c558-72bc-8c95-0d077bf84c24.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, dining area with a round table and chairs, and wood-paneled accent wall.",
        "public_id": "019db589-c558-72bc-8c95-0d077bf84c24",
        "storage_key": "property/6767906449166543/019db589-c558-72bc-8c95-0d077bf84c24.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious living area, featuring a comfortable gray sofa, elegant dining set, and a stylish wood-paneled accent wall. Perfect for modern living.",
      "link": "",
      "alt_text": "Living room with a gray sofa, dining area with a round table and chairs, and wood-paneled accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7ceeefc-b598-42b2-b700-5aed9150dfdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-c7e4-70bb-9cbd-f8015fd77c72.webp",
      "image_media": {
        "alt_text": "View from balcony of apartment building exterior and courtyard",
        "public_id": "019db589-c7e4-70bb-9cbd-f8015fd77c72",
        "storage_key": "property/6767906449166543/019db589-c7e4-70bb-9cbd-f8015fd77c72.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy your private balcony with a view of the beautifully maintained courtyard and surrounding buildings. Relax and take in the fresh air.",
      "link": "",
      "alt_text": "View from balcony of apartment building exterior and courtyard",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5479ccea-c24e-4ae7-a62a-26145cdc5e25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-c8e1-732a-930e-e8dae21ca7ab.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, stainless steel sink, white dishwasher, and white stove.",
        "public_id": "019db589-c8e1-732a-930e-e8dae21ca7ab",
        "storage_key": "property/6767906449166543/019db589-c8e1-732a-930e-e8dae21ca7ab.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring ample cabinet space, a functional sink area, and modern appliances, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, stainless steel sink, white dishwasher, and white stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f99fd55f-cd2d-4380-8078-e06a8186c937",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-9e75-7733-bfbd-2c0268c6e968.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel sink, dishwasher, and black refrigerator.",
        "public_id": "019db589-9e75-7733-bfbd-2c0268c6e968",
        "storage_key": "property/6767906449166543/019db589-9e75-7733-bfbd-2c0268c6e968.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring sleek dark wood cabinetry, durable granite countertops, a deep stainless steel sink, a convenient dishwasher, and a classic black refrigerator.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel sink, dishwasher, and black refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67e35cb4-982f-452b-994b-6749154420c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-9f64-7263-ac66-3778511902ed.webp",
      "image_media": {
        "alt_text": "Tennis courts surrounded by a chain-link fence and green grass on a sunny day.",
        "public_id": "019db589-9f64-7263-ac66-3778511902ed",
        "storage_key": "property/6767906449166543/019db589-9f64-7263-ac66-3778511902ed.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our well-maintained tennis courts, a perfect amenity for active residents.",
      "link": "",
      "alt_text": "Tennis courts surrounded by a chain-link fence and green grass on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67855ed9-a391-4ca0-a576-853bffd6af68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-a1ce-7238-9831-0f0daa960bde.webp",
      "image_media": {
        "alt_text": "Bedroom with a wooden bed frame, patterned comforter, and two nightstands.",
        "public_id": "019db589-a1ce-7238-9831-0f0daa960bde",
        "storage_key": "property/6767906449166543/019db589-a1ce-7238-9831-0f0daa960bde.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with a stylish patterned comforter, a wooden headboard, and two matching nightstands. Modern wall art adds a touch of color.",
      "link": "",
      "alt_text": "Bedroom with a wooden bed frame, patterned comforter, and two nightstands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e313e8a9-233b-4d1d-94e9-0a1ca0a4aaf7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-a1cd-713b-8fd4-ff0eeed4d48c.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink.",
        "public_id": "019db589-a1cd-713b-8fd4-ff0eeed4d48c",
        "storage_key": "property/6767906449166543/019db589-a1cd-713b-8fd4-ff0eeed4d48c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a bathtub, toilet, and a spacious vanity with a sink. The wood cabinets provide ample storage.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e264b424-77ca-4502-a866-aef8d91747e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-a062-77ac-a337-575538051785.webp",
      "image_media": {
        "alt_text": "Tennis courts with red and green surfaces under a blue sky with clouds.",
        "public_id": "019db589-a062-77ac-a337-575538051785",
        "storage_key": "property/6767906449166543/019db589-a062-77ac-a337-575538051785.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our well-maintained tennis courts, perfect for a friendly match or a vigorous workout.",
      "link": "",
      "alt_text": "Tennis courts with red and green surfaces under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_25955af7-ba04-4dca-aa06-496f3239bed4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-9ef7-704d-b894-a1b87357d9a5.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances and wood cabinets",
        "public_id": "019db589-9ef7-704d-b894-a1b87357d9a5",
        "storage_key": "property/6767906449166543/019db589-9ef7-704d-b894-a1b87357d9a5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring black appliances, ample cabinet space, and granite countertops. Perfect for your culinary adventures.",
      "link": "",
      "alt_text": "Kitchen with black appliances and wood cabinets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5914aff1-12e6-4109-ac25-74ee3005309a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-4a32-73e1-b2d8-f2f04367a849.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving",
        "public_id": "019db589-4a32-73e1-b2d8-f2f04367a849",
        "storage_key": "property/6767906449166543/019db589-4a32-73e1-b2d8-f2f04367a849.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dff151d8-c404-40ca-a42b-352da13c4123",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-3f25-7430-98b4-9c4211d1f0dd.webp",
      "image_media": {
        "alt_text": "View from balcony of a grassy field and building exterior.",
        "public_id": "019db589-3f25-7430-98b4-9c4211d1f0dd",
        "storage_key": "property/6767906449166543/019db589-3f25-7430-98b4-9c4211d1f0dd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the fresh air and open views from your private balcony, overlooking a lush green courtyard and the surrounding community.",
      "link": "",
      "alt_text": "View from balcony of a grassy field and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0fd922dc-f304-4944-bb9b-3b58ce850e40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-173a-7221-8e87-5e470a57612b.webp",
      "image_media": {
        "alt_text": "Spacious high-ceiling community lounge with modern furniture and decor.",
        "public_id": "019db589-173a-7221-8e87-5e470a57612b",
        "storage_key": "property/6767906449166543/019db589-173a-7221-8e87-5e470a57612b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed community lounge, featuring comfortable seating, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Spacious high-ceiling community lounge with modern furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_77a98ca2-194e-45af-a8e6-9b79326951eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-27a9-736d-99c7-98bf3afcbed9.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building entrance with parking and landscaping.",
        "public_id": "019db589-27a9-736d-99c7-98bf3afcbed9",
        "storage_key": "property/6767906449166543/019db589-27a9-736d-99c7-98bf3afcbed9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to the apartment building entrance, featuring a walkway, landscaping, and parking. Discover your new home today.",
      "link": "",
      "alt_text": "Exterior of apartment building entrance with parking and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a2bb86b-dc34-4bba-84f7-d5d75ea32ea8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-2192-735a-88d4-d247a92e5a99.webp",
      "image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping and white fence.",
        "public_id": "019db589-2192-735a-88d4-d247a92e5a99",
        "storage_key": "property/6767906449166543/019db589-2192-735a-88d4-d247a92e5a99.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Aspen Park Apartments, featuring a beautifully landscaped monument sign and white picket fence for a charming entrance.",
      "link": "",
      "alt_text": "Aspen Park Apartments monument sign with landscaping and white fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_696086f0-2a9a-46e7-be8c-5bb8cfeb3a40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-170f-7339-9326-dea7206356eb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019db589-170f-7339-9326-dea7206356eb",
        "storage_key": "property/6767906449166543/019db589-170f-7339-9326-dea7206356eb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e3e72f53-da60-4efa-a5d3-fe1b8da12213",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-1668-74a9-8347-38a2aabdae1f.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019db589-1668-74a9-8347-38a2aabdae1f",
        "storage_key": "property/6767906449166543/019db589-1668-74a9-8347-38a2aabdae1f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs for soaking up the sun. Enjoy the resort-style amenities.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_853f834f-7bf0-440a-b44a-451cc3413dcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-1589-72cd-9508-936d93eabdee.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a fireplace, comfortable seating, and decorative elements.",
        "public_id": "019db589-1589-72cd-9508-936d93eabdee",
        "storage_key": "property/6767906449166543/019db589-1589-72cd-9508-936d93eabdee.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed communal lounge, featuring a stylish fireplace and ample seating.",
      "link": "",
      "alt_text": "Modern communal lounge area with a fireplace, comfortable seating, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_434d0abc-9377-4cc7-a534-773876685fe4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-0a35-707f-ad4a-049d66792ed3.webp",
      "image_media": {
        "alt_text": "Clubhouse common area with fireplace and view of outdoor pool.",
        "public_id": "019db589-0a35-707f-ad4a-049d66792ed3",
        "storage_key": "property/6767906449166543/019db589-0a35-707f-ad4a-049d66792ed3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed clubhouse common area, featuring a modern fireplace and comfortable seating. Enjoy views of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Clubhouse common area with fireplace and view of outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19befe21-93c7-4328-8334-d439de611710",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db588-fde4-736b-aab0-39b1062a882f.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers on the left and single washers on the right.",
        "public_id": "019db588-fde4-736b-aab0-39b1062a882f",
        "storage_key": "property/6767906449166543/019db588-fde4-736b-aab0-39b1062a882f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washing and drying machines for residents.",
      "link": "",
      "alt_text": "Laundry room with stacked washers and dryers on the left and single washers on the right.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_230c3a9b-5e02-41c3-a39b-5656ee23e651",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db588-fdec-703f-aaa6-0f3cdcd8f56e.webp",
      "image_media": {
        "alt_text": "Treadmills, elliptical, and dumbbell rack in apartment complex gym.",
        "public_id": "019db588-fdec-703f-aaa6-0f3cdcd8f56e",
        "storage_key": "property/6767906449166543/019db588-fdec-703f-aaa6-0f3cdcd8f56e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Get your workout in at our fully-equipped fitness center, featuring treadmills, ellipticals, and a selection of free weights. Stay motivated with on-screen entertainment.",
      "link": "",
      "alt_text": "Treadmills, elliptical, and dumbbell rack in apartment complex gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b8b52a9c-8c09-4cd3-b784-90023028fa7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db588-d9a6-76fd-b417-42650fd2f4d6.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, dumbbells, and TV.",
        "public_id": "019db588-d9a6-76fd-b417-42650fd2f4d6",
        "storage_key": "property/6767906449166543/019db588-d9a6-76fd-b417-42650fd2f4d6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines like treadmills and ellipticals, as well as a comprehensive set of free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, dumbbells, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_68779abb-931a-4cdf-b8e1-40f17415e0a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6707 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and appetizers, and the food is consistently good. They highlight the fun, lively atmosphere and the generous portions of rolls and cinnamon butter. They also like the attentive and friendly service.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-west-kellogg?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10790040154516989602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.6720244",
      "poi_longitude": "-97.4200102",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-943-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_Fxv7nguocRoqYvOlrsvZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ff6cd758-e68f-4c2d-95bd-923908db43e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "7320 W Taft St, Wichita, KS 67209, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, waffle fries, and fresh salads. They highlight the friendly staff and quick service, especially for online orders. They also like the clean facility and positive, Christian vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-aa79-727a-8ed3-cc68f5f6ff27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-aa79-727a-8ed3-cc68f5f6ff27",
        "storage_key": "property/6767906449166543/019cfb4e-aa79-727a-8ed3-cc68f5f6ff27.webp",
        "width": 782,
        "height": 430
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/maple-ridge?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3878166640798646112&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.6772557",
      "poi_longitude": "-97.4268918",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-729-2697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2yIMLvhuocRYL-SLAME0jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_cfee4c53-cdcc-4156-8664-764952eed507",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "HomeGrown",
      "poi_type": "Restaurants",
      "poi_address": "645 E Douglas Ave Ste 102, Wichita, KS 67202, USA",
      "poi_short_description": "Open-space eatery with a 'choose kind' motto, serving breakfast items and lunch dishes such as pancakes, waffles and French toast.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits and gravy, French toast, and gluten-free pancakes. They highlight the fresh, locally sourced ingredients and the affordable prices. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-74c4-74b8-88db-7511c9f5bd78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-74c4-74b8-88db-7511c9f5bd78",
        "storage_key": "property/6767906449166543/019cfb4e-74c4-74b8-88db-7511c9f5bd78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homegrownkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10686225532294437036&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "homegrown",
      "poi_latitude": "37.6856462",
      "poi_longitude": "-97.3309449",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-247-9509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaY-BPffjuocRrJge6oAZTZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_1690bc30-3ae2-40d2-bc92-009afe7d3bc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Doo-Dah Diner",
      "poi_type": "Restaurants",
      "poi_address": "206 E Kellogg St, Wichita, KS 67202, USA",
      "poi_short_description": "Homey diner serving from-scratch American breakfast & lunch classics, from pancakes to burgers.",
      "poi_long_description": "People say this diner serves delicious banana bread French toast, biscuits and gravy, and monkey bread. They highlight the generous portions, homemade food, and fun, cozy vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-752f-74b4-970d-23b76f406ac2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-752f-74b4-970d-23b76f406ac2",
        "storage_key": "property/6767906449166543/019cfb4e-752f-74b4-970d-23b76f406ac2.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://doodahdiner.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12690445211555488726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "doo-dah-diner",
      "poi_latitude": "37.6796006",
      "poi_longitude": "-97.3364484",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13z0ke7juocR1mNS3K6EHbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_a0db4608-c803-42e1-80cc-b14177c051e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Tacos TJ 664",
      "poi_type": "Restaurants",
      "poi_address": "1014 N West St, Wichita, KS 67203, USA",
      "poi_short_description": "Casual restaurant (part of a chain) dishing out Mexican plates such as tacos, burritos and quesadillas, plus beer and margaritas.",
      "poi_long_description": "People say this taco restaurant serves authentic and flavorful birria tacos, carne asada fries, and quesadillas. They highlight the generous portions, affordable prices, and great value. They also like the friendly staff and laid-back atmosphere.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://tacostj664.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10506997636259729300&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacos-tj-664",
      "poi_latitude": "37.7020358",
      "poi_longitude": "-97.3891816",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-461-0610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53QS5_fjuocRlE8hha5a0JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_b8b6a587-0ada-4baa-9a9d-00b51ff0af60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8444 W McCormick Ave, Wichita, KS 67209, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products for home and garden projects. They also highlight the helpful and professional staff, and the well-stocked and clean store.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-755a-729b-8f76-b8f13d43e252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-755a-729b-8f76-b8f13d43e252",
        "storage_key": "property/6767906449166543/019cfb4e-755a-729b-8f76-b8f13d43e252.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/West-Wichita/KS/Wichita/67209/2205?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13722908378629795426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.6738686",
      "poi_longitude": "-97.4402648",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-773-1988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ0S0uR3euocRYu51mXaQcb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_aee50220-7000-4304-8f96-53b9af3adb3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3660 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of building supplies, hardware, patio equipment, appliances, paint, lighting, and lawn and garden decor. They also highlight the good prices, easy returns, and helpful staff.\n\nOther reviews mention the store can be difficult to navigate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-74aa-77e8-a673-9776fa60ab7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-74aa-77e8-a673-9776fa60ab7e",
        "storage_key": "property/6767906449166543/019cfb4e-74aa-77e8-a673-9776fa60ab7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3276&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4195684929713849559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.7497617",
      "poi_longitude": "-97.4597743",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-729-5851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp792U3Igu4cR18QNwTYROjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_bfacb991-4f66-46d6-a620-8694c4123398",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "333 S Ridge Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a great collection of plants. They also highlight the staff is helpful and easy to park.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-74db-75ca-8127-08d694a0ad10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-74db-75ca-8127-08d694a0ad10",
        "storage_key": "property/6767906449166543/019cfb4e-74db-75ca-8127-08d694a0ad10.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/KS-Wichita/0614?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-614-_-na-_-0-_-0&y_source=1_MTE4MzEwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050313256936817436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "37.678859",
      "poi_longitude": "-97.428188",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-773-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPUZP16LguocRHEPaHJLhnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b2b919a1-37d0-4771-9048-d1477b983a4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Thai Binh Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1530 W 21st St, Wichita, KS 67203, USA",
      "poi_short_description": "Sprawling Asian-style grocery stocking produce and cooking utensils, plus hot foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-756c-702f-bbce-128648d219cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-756c-702f-bbce-128648d219cc",
        "storage_key": "property/6767906449166543/019cfb4e-756c-702f-bbce-128648d219cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Thai-Binh-Supermarket/165438916815347",
      "poi_directions_map_url": "https://maps.google.com/?cid=12975717193484190098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thai-binh-supermarket",
      "poi_latitude": "37.723579",
      "poi_longitude": "-97.355179",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-838-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8728-70e0-882d-d7928ead0897.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8728-70e0-882d-d7928ead0897",
        "storage_key": "property/6767906449166543/019cfb4e-8728-70e0-882d-d7928ead0897.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMceJz4vhuocRksGNBwoCE7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_0577c44c-4afb-4a3b-8eec-da0792272f85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Mi Super Mercado Baratísimo - Seneca - Wichita",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 S Seneca St, Wichita, KS 67217, USA",
      "poi_short_description": "Traditional Mexican grocery store featuring fresh produce, desserts, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-aa85-7353-8633-110c144ecd1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-aa85-7353-8633-110c144ecd1a",
        "storage_key": "property/6767906449166543/019cfb4e-aa85-7353-8633-110c144ecd1a.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.elriobravokck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6659820061076927&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mi-super-mercado-baratsimo---seneca---wichita",
      "poi_latitude": "37.6493786",
      "poi_longitude": "-97.3545534",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-269-9119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8728-70e0-882d-d7928ead0897.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8728-70e0-882d-d7928ead0897",
        "storage_key": "property/6767906449166543/019cfb4e-8728-70e0-882d-d7928ead0897.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaCidSHnuocRvy0CMRKpFwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_72a67354-fdb7-474e-ad47-aa7ab465a895",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wichita Public Library - Advanced Learning Library",
      "poi_type": "Education",
      "poi_address": "711 West 2nd St N, Wichita, KS 67203, USA",
      "poi_short_description": "Relaxed public library featuring books and media for kids and adults, plus play spaces, a studio and computers.",
      "poi_long_description": "People say this public library offers a wide selection of books, access to technology, and free classes and live events. They highlight the clean and quiet atmosphere, and the spacious layout with plenty of seating. They also like the helpful staff and the availability of meeting rooms.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wichitalibrary.org/Locations/Pages/advanced-learning-library.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1540515458718365609&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-public-library---advanced-learning-library",
      "poi_latitude": "37.68664890000001",
      "poi_longitude": "-97.3479505",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-261-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfx2pGt7juocRqffnz6UCYRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_db78fe2d-3e83-48bc-ae88-c4a4989086b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Friends University",
      "poi_type": "Education",
      "poi_address": "2100 W Univ Ave, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.friends.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570531106663261673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friends-university",
      "poi_latitude": "37.6777089",
      "poi_longitude": "-97.3666702",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-295-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-zLPUThuocR6WXVmIujFdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ad7c17c6-3227-435d-917a-6a057480cf7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Newman University",
      "poi_type": "Education",
      "poi_address": "3100 McCormick St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.newmanu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8197001651856080544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newman-university",
      "poi_latitude": "37.673508",
      "poi_longitude": "-97.377744",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-942-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjRoRMzHhuocRoP4ropKZwXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e5fafbc5-9065-4ee3-a75b-8884d58def88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Sedgwick County Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "Animals organized by continent, plus educational programs for various age groups.",
      "poi_long_description": "Visitors say this zoo offers a variety of animal experiences, including giraffe feeding, stingray cove, a train ride, and a boat ride, and they praise the well-maintained habitats and friendly staff. They also highlight the family-friendly atmosphere, affordable season passes, and numerous special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-aab0-7438-979e-5e2e35e5df36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-aab0-7438-979e-5e2e35e5df36",
        "storage_key": "property/6767906449166543/019cfb4e-aab0-7438-979e-5e2e35e5df36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://scz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432857233417595508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-zoo",
      "poi_latitude": "37.717034",
      "poi_longitude": "-97.408561",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-660-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVutukTguocRdGqcdRSrqZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_7560b34c-df4f-404d-a7e4-df7ea7836b11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Exploration Place",
      "poi_type": "Entertainment",
      "poi_address": "300 N McLean Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Exhibits, films, live shows, & hands-on science & discovery programs for kids and adults.",
      "poi_long_description": "People say this science museum offers interactive exhibits, a shark exhibit, and a dome theater. They highlight the educational and entertaining experience, and the fun, hands-on activities for kids and adults. They also like the friendly and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.exploration.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209503253032261092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "exploration-place",
      "poi_latitude": "37.6894665",
      "poi_longitude": "-97.3479609",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-660-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8709-72da-8a3b-64bc46a4fa14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8709-72da-8a3b-64bc46a4fa14",
        "storage_key": "property/6767906449166543/019cfb4e-8709-72da-8a3b-64bc46a4fa14.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7tm5d7juocR5NW-Z-xLMsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_939b6ce4-68e5-459f-b337-8d6c5dfdbb30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "INTRUST Bank Arena",
      "poi_type": "Entertainment",
      "poi_address": "500 E Waterman St, Wichita, KS 67202, USA",
      "poi_short_description": "State-of-the-art entertainment complex hosting sports, concerts, ice shows & conventions.",
      "poi_long_description": "People say this arena offers a variety of events, including hockey games and concerts. They also highlight the clean and well-laid-out venue, comfortable seating, and friendly staff.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-798b-723d-9dc9-87ecd01c61ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-798b-723d-9dc9-87ecd01c61ed",
        "storage_key": "property/6767906449166543/019cfb4e-798b-723d-9dc9-87ecd01c61ed.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.intrustbankarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2995336029531607261&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intrust-bank-arena",
      "poi_latitude": "37.6832771",
      "poi_longitude": "-97.3320617",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-755-7328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59VNcOvjuocR3RAptz-SkSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_7bc1bf4e-be6c-4783-ac96-00932330604f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wichita Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Contemporary & historical works from a 7,000-piece permanent collection, & a hands-on area for kids.",
      "poi_long_description": "People say this art museum offers a diverse collection of paintings, photography, and sculptures, including works by local artists and children. They highlight the free admission, the beautiful and colorful entrance, and the rotating exhibits and themes. They also like the family-friendly atmosphere and the fun activities for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-7a11-7512-86f5-9af6df68ee9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-7a11-7512-86f5-9af6df68ee9b",
        "storage_key": "property/6767906449166543/019cfb4e-7a11-7512-86f5-9af6df68ee9b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://wam.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14953396795402545430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-art-museum",
      "poi_latitude": "37.6949197",
      "poi_longitude": "-97.3559687",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-268-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8709-72da-8a3b-64bc46a4fa14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8709-72da-8a3b-64bc46a4fa14",
        "storage_key": "property/6767906449166543/019cfb4e-8709-72da-8a3b-64bc46a4fa14.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0d-QWPhuocRFulurygjhc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_326bc115-22ed-4a29-84ed-30573dd5de1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "8545 W Irving St, Wichita, KS 67209, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, a zip line, and a ropes course. They also highlight the clean facility and the friendly, helpful staff.\n\nOther reviews mention the height requirements can be unclear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-79fb-7734-a337-4eeac449f1e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-79fb-7734-a337-4eeac449f1e2",
        "storage_key": "property/6767906449166543/019cfb4e-79fb-7734-a337-4eeac449f1e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/kansas-wichita/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075506925871037131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "37.6701433",
      "poi_longitude": "-97.4414467",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-281-7173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITbj0RzeuocRy_pbug9AMWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8812cdcc-e192-447c-8b16-7aec59f5d55f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "WEST YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "6940 Newell St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, including yoga, and has a kid zone. They also highlight the friendly staff and welcoming, homely vibe.\n\nOther reviews mention billing issues can be difficult to resolve.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-abfb-714c-8539-575ddefa7dfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-abfb-714c-8539-575ddefa7dfb",
        "storage_key": "property/6767906449166543/019cfb4e-abfb-714c-8539-575ddefa7dfb.webp",
        "width": 504,
        "height": 378
      },
      "poi_business_url": "https://www.ymcawichita.org/locations/west-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=4228409214553971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6928199",
      "poi_longitude": "-97.4231272",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-942-2271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-onBo7guocRPFx6DsdTrjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0fcfc9d9-ea63-410a-888f-d48a47bcd53b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Richard A. DeVore SOUTH YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3405 S Meridian Ave Bldg. 1, Wichita, KS 67217, USA",
      "poi_short_description": "Fitness center offering clean facilities, exercise machines, hot tubs, and pools, plus classes.",
      "poi_long_description": "People say this gym offers a variety of equipment and classes. They also highlight the friendly staff and the convenient location.\n\nSome reviews mention the management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-ac02-721b-aa06-838650d0fe30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-ac02-721b-aa06-838650d0fe30",
        "storage_key": "property/6767906449166543/019cfb4e-ac02-721b-aa06-838650d0fe30.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcawichita.org/locations/richard-devore-south-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6072621654783976938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richard-a-devore-south-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6309425",
      "poi_longitude": "-97.3764392",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-942-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fD39JLmuocR6mW-jDhJRlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6b5c13f6-6c31-4e24-a370-03c0b2277fb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Ken Shannon NORTHWEST Branch - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "13838 W 21st St N, Wichita, KS 67235, USA",
      "poi_short_description": "Familiar fitness club offering workout machines, classes (including swimming, yoga and Pilates), a pool and friendly staff, plus a sauna and steam room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-7a5c-76af-9b3a-71e162cd3f39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-7a5c-76af-9b3a-71e162cd3f39",
        "storage_key": "property/6767906449166543/019cfb4e-7a5c-76af-9b3a-71e162cd3f39.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://ymcawichita.org/locations/ken-shannon-northwest-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593200057211516548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ken-shannon-northwest-branch---greater-wichita-ymca",
      "poi_latitude": "37.7232046",
      "poi_longitude": "-97.5035287",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-260-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5XYsWvfuocRhHYtD4XAf1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7c050fcf-133a-4be7-af81-fbe7b7c4fbbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Robert D. Love Downtown YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "402 N Market St, Wichita, KS 67202, USA",
      "poi_short_description": "Nonprofit community center with an indoor track, pools, and courts for racquetball and basketball.",
      "poi_long_description": "People say this gym offers a variety of equipment, a pool, and a track. They also highlight the spacious layout, the separate saunas, and the friendly staff.\n\nOther reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-ac13-710f-a9a9-66dddc572381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-ac13-710f-a9a9-66dddc572381",
        "storage_key": "property/6767906449166543/019cfb4e-ac13-710f-a9a9-66dddc572381.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcawichita.org/locations/robert-d-love-downtown-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=2962762509539940888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "robert-d-love-downtown-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6924977",
      "poi_longitude": "-97.33655720000002",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-264-9374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfK39MPjuocRGBr5Fs7YHSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_603c55b5-71a5-4d40-8639-6450285e370d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop North Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "727 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "Barbershop featuring a friendly staff of skilled pros, plus kids' cuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-7a93-73e0-b79d-4435b91a994f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-7a93-73e0-b79d-4435b91a994f",
        "storage_key": "property/6767906449166543/019cfb4e-7a93-73e0-b79d-4435b91a994f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-north-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=13837457956166592306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-north-wichita",
      "poi_latitude": "37.7076339",
      "poi_longitude": "-97.3476791",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-219-3132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcaWNiviuocRMme2d7KGCMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_32267a43-119a-4c97-bbe4-27ff82690e14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Veterinary Emergency & Specialty Hospital of Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "5618 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-ad89-77df-8dc6-d59734d31bb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-ad89-77df-8dc6-d59734d31bb7",
        "storage_key": "property/6767906449166543/019cfb4e-ad89-77df-8dc6-d59734d31bb7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vetwichita.com/?y_source=1_MTUyMjkzNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9151561644725192073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-emergency--specialty-hospital-of-wichita",
      "poi_latitude": "37.7241153",
      "poi_longitude": "-97.4087979",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-262-5321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_YLl43juocRiUXvLdTgAH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f8ef1e40-13ac-4421-8d81-6709136330cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - West Central",
      "poi_type": "Health and Wellness",
      "poi_address": "854 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "Gym and tennis club featuring weight machines, group classes, personal trainers, a pool, saunas and clean locker rooms.",
      "poi_long_description": "People say this gym offers personal training packages and nutrient products. They also highlight the 24-hour access.\n\nOther reviews mention the equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-7d2c-7420-ae38-5a67a5ec18a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-7d2c-7420-ae38-5a67a5ec18a3",
        "storage_key": "property/6767906449166543/019cfb4e-7d2c-7420-ae38-5a67a5ec18a3.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/west-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3017945090160134620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---west-central",
      "poi_latitude": "37.6974426",
      "poi_longitude": "-97.4363575",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-721-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQpmYNjfuocR3Amh2hHl4Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eeb29882-4150-4b8c-9845-92e9d847c9ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 N Amidon Ave, Wichita, KS 67203, USA",
      "poi_short_description": "Welcoming facility featuring strength-training equipment, cardio machines and tanning beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-add1-7428-bdc8-e7ee324a74a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-add1-7428-bdc8-e7ee324a74a3",
        "storage_key": "property/6767906449166543/019cfb4e-add1-7428-bdc8-e7ee324a74a3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-new-leaf-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068367135117192520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.72080589999999",
      "poi_longitude": "-97.3649016",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-440-4808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1Ivu5HhuocRSK1Q_8ErN1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8a348a38-1999-44a5-96d0-73cc49228e13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Limitless Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "8635 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Barbershop offering a variety of haircuts, including fades, in a friendly setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-7dd7-703f-933a-415d1fe36ce9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-7dd7-703f-933a-415d1fe36ce9",
        "storage_key": "property/6767906449166543/019cfb4e-7dd7-703f-933a-415d1fe36ce9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.limitlessbarbershop.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406037866442402230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "limitless-barbershop",
      "poi_latitude": "37.6927246",
      "poi_longitude": "-97.4428108",
      "poi_miles_from_property": "0.07",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 316-469-8087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwzn3G_fuocRtilwGbH2YyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_c6e73cde-42a7-422c-993a-fcc24ec1a325",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "929 St Francis, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-ae2a-704a-9b1f-2b0d5398240d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-ae2a-704a-9b1f-2b0d5398240d",
        "storage_key": "property/6767906449166543/019cfb4e-ae2a-704a-9b1f-2b0d5398240d.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-francis?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408748786587986507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-francis",
      "poi_latitude": "37.6994424",
      "poi_longitude": "-97.3324685",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-870a-7668-b511-80c4b6a9f765.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-870a-7668-b511-80c4b6a9f765",
        "storage_key": "property/6767906449166543/019cfb4e-870a-7668-b511-80c4b6a9f765.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQufU8jjuocRS-oyiRWWt-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d9f520f8-0bdd-4bcb-8de5-32086b2b028a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Teresa",
      "poi_type": "Health and Wellness",
      "poi_address": "14800 St Teresa St, Wichita, KS 67235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-ae4d-72cb-911d-e05bc8973c5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-ae4d-72cb-911d-e05bc8973c5a",
        "storage_key": "property/6767906449166543/019cfb4e-ae4d-72cb-911d-e05bc8973c5a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-teresa?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15586166186925347435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-teresa",
      "poi_latitude": "37.7257513",
      "poi_longitude": "-97.5132964",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-796-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-870a-7668-b511-80c4b6a9f765.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-870a-7668-b511-80c4b6a9f765",
        "storage_key": "property/6767906449166543/019cfb4e-870a-7668-b511-80c4b6a9f765.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVzCgkXfuocRa9LjZZEvTdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e2c6377d-da98-4b1a-8d2c-a65f2ad8a4d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Botanica, The Wichita Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 Amidon St, Wichita, KS 67203, USA",
      "poi_short_description": "Imaginative, verdant botanical garden with children's areas, a butterfly house, events & more.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, a butterfly house, and a children's play area. They highlight the beautiful grounds, the fun and engaging activities for families, and the peaceful and tranquil atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-afb0-74af-a13e-28e4a472dc18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-afb0-74af-a13e-28e4a472dc18",
        "storage_key": "property/6767906449166543/019cfb4e-afb0-74af-a13e-28e4a472dc18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.botanica.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898597451770473856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "botanica-the-wichita-gardens",
      "poi_latitude": "37.6964308",
      "poi_longitude": "-97.361781",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-264-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeda7xm_huocRgK1RPHJzws4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_505ba9dd-f804-40e3-9504-eec1f99f1212",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Sedgwick County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Center for outdoor sports, recreation & fitness, with fishing on 4 lakes, plus shelter rentals.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, walking and biking trails, fishing, and picnic areas. They highlight the spaciousness, beautiful scenery, and family-friendly atmosphere. They also like the well-maintained facilities and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-7ebc-70c2-a432-acaea687719c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-7ebc-70c2-a432-acaea687719c",
        "storage_key": "property/6767906449166543/019cfb4e-7ebc-70c2-a432-acaea687719c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sedgwickcounty.org/parks/sedgwick-county-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1140188679586598057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-park",
      "poi_latitude": "37.7093827",
      "poi_longitude": "-97.4184872",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-660-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871d-7239-9318-56d188fddd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871d-7239-9318-56d188fddd1d",
        "storage_key": "property/6767906449166543/019cfb4e-871d-7239-9318-56d188fddd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6auLGjguocRqUyuJ5DD0g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1560c18d-6ce6-4064-bbb5-0046d0941f0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Pawnee Prairie Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2625 S Tyler Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Spacious outdoor park with trails for walking, biking & horseback-riding, plus picnic areas.",
      "poi_long_description": "People say this park offers beautiful walking trails, a bike path, and opportunities to see wildlife. They highlight the peaceful and natural escape from the city, and the well-maintained paths suitable for various skill levels. They also like the diverse trails, including a smooth path for beginners and more moderate dirt paths. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-b20a-736a-8aa5-706ee0c96ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-b20a-736a-8aa5-706ee0c96ee5",
        "storage_key": "property/6767906449166543/019cfb4e-b20a-736a-8aa5-706ee0c96ee5.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Pawnee-Prairie-Park-200",
      "poi_directions_map_url": "https://maps.google.com/?cid=7082970089037678459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pawnee-prairie-park",
      "poi_latitude": "37.65121",
      "poi_longitude": "-97.4566587",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871d-7239-9318-56d188fddd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871d-7239-9318-56d188fddd1d",
        "storage_key": "property/6767906449166543/019cfb4e-871d-7239-9318-56d188fddd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99dH-O_duocRe8fOz8TDS2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a245cbd3-8ff2-4045-b414-61cba3783dd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Central Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "720 Nims, Wichita, KS 67203, USA",
      "poi_short_description": "Large park featuring a miniature zoo, playgrounds, a splash pad, walking paths & picnic areas.",
      "poi_long_description": "Visitors say this city park is a great place for picnics, with plenty of trees and space to play Frisbee. They also highlight the playground and barbecue areas, making it a popular spot for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-812b-773e-8e58-a492859175b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-812b-773e-8e58-a492859175b0",
        "storage_key": "property/6767906449166543/019cfb4e-812b-773e-8e58-a492859175b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Central-Riverside-Park-43",
      "poi_directions_map_url": "https://maps.google.com/?cid=10285259190793395628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-riverside-park",
      "poi_latitude": "37.6970794",
      "poi_longitude": "-97.3466547",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871d-7239-9318-56d188fddd1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871d-7239-9318-56d188fddd1d",
        "storage_key": "property/6767906449166543/019cfb4e-871d-7239-9318-56d188fddd1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJicxOUdfjuocRrN0Pir2UvI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b791bd9b-0eab-4f8d-988b-38c5b212a102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Auburn Hills Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "443 S 135th St W, Wichita, KS 67235, USA",
      "poi_short_description": "Public course featuring 18 holes with tight corridors, rolling hills and wetlands areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8116-718b-82a6-621385ab9a61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8116-718b-82a6-621385ab9a61",
        "storage_key": "property/6767906449166543/019cfb4e-8116-718b-82a6-621385ab9a61.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Auburn-Hills-Golf-Course-148",
      "poi_directions_map_url": "https://maps.google.com/?cid=15217307189274254099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn-hills-golf-course",
      "poi_latitude": "37.6740167",
      "poi_longitude": "-97.4989223",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-219-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871f-71ae-a444-a802a357a423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871f-71ae-a444-a802a357a423",
        "storage_key": "property/6767906449166543/019cfb4e-871f-71ae-a444-a802a357a423.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4geZefiuocRE5uwjkO8LtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_24c6f1f4-f815-4153-b543-e8bd767d96c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wichita Dwight D. Eisenhower National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2277 Eisenhower Airport Pkwy, Wichita, KS 67209, USA",
      "poi_short_description": "Regional airport offering a host of domestic flights to & from the largest city in Kansas.",
      "poi_long_description": "Visitors say this airport is clean, easy to navigate, and has friendly staff. They also highlight its convenient rental car pickup and drop-off, quick security lines, and efficient check-in process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-b22a-764b-be94-5ffdf5893654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-b22a-764b-be94-5ffdf5893654",
        "storage_key": "property/6767906449166543/019cfb4e-b22a-764b-be94-5ffdf5893654.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.flywichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8128607608438818969&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-dwight-d-eisenhower-national-airport",
      "poi_latitude": "37.6493348",
      "poi_longitude": "-97.4273195",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-946-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8713-76af-bcc4-c90328ec5e43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8713-76af-bcc4-c90328ec5e43",
        "storage_key": "property/6767906449166543/019cfb4e-8713-76af-bcc4-c90328ec5e43.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0QnDVHnuocRmYiIe42dznA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_15c302f4-e808-4774-823d-eec569b77754",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Textron Aviation C5",
      "poi_type": "Transportation & Transit",
      "poi_address": "C5, Wichita, KS 67209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10430272576288837024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c5",
      "poi_latitude": "37.6400806",
      "poi_longitude": "-97.4226631",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8713-76af-bcc4-c90328ec5e43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8713-76af-bcc4-c90328ec5e43",
        "storage_key": "property/6767906449166543/019cfb4e-8713-76af-bcc4-c90328ec5e43.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ZkKB0jnuocRoM0xbKXFv5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d669d81c-cbee-472e-8487-655a44fd432a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Westport Airport-71K",
      "poi_type": "Transportation & Transit",
      "poi_address": "2558 S Kessler St, Wichita, KS 67217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-b424-77da-a2de-7e143d4e4203.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-b424-77da-a2de-7e143d4e4203",
        "storage_key": "property/6767906449166543/019cfb4e-b424-77da-a2de-7e143d4e4203.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4024429820277561674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westport-airport-71k",
      "poi_latitude": "37.6482314",
      "poi_longitude": "-97.384478",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-943-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8713-76af-bcc4-c90328ec5e43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8713-76af-bcc4-c90328ec5e43",
        "storage_key": "property/6767906449166543/019cfb4e-8713-76af-bcc4-c90328ec5e43.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4S_s8TmuocRShkiZZml2Tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ea1c97fb-4966-4fb0-af63-1202f2d54c5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "City of Wichita ​City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "455 N Main, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-b361-71dd-9d46-a4dd4db49c6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-b361-71dd-9d46-a4dd4db49c6a",
        "storage_key": "property/6767906449166543/019cfb4e-b361-71dd-9d46-a4dd4db49c6a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4707618743980993027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-wichita-city-hall",
      "poi_latitude": "37.6929601",
      "poi_longitude": "-97.339002",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-942-4482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8a27-740e-a27e-8ec8a32a2517.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8a27-740e-a27e-8ec8a32a2517",
        "storage_key": "property/6767906449166543/019cfb4e-8a27-740e-a27e-8ec8a32a2517.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVI-vcTjuocRAyr1PE7SVEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_2b26849a-66a6-4b6f-a0ae-6f049d30a4ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "BG Products, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "740 S Wichita St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-b51f-74eb-b144-6b6e583b77e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-b51f-74eb-b144-6b6e583b77e0",
        "storage_key": "property/6767906449166543/019cfb4e-b51f-74eb-b144-6b6e583b77e0.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://www.bgprod.com/?utm_source=google&utm_medium=company-profile&utm_content=website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729482907961109433&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bg-products-inc",
      "poi_latitude": "37.67794190000001",
      "poi_longitude": "-97.3403841",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-961-6228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxN7feXjuocRuavp9PHIwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b638b1c2-e638-4a6e-a40f-4349185632af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Textron Aviation C6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2655 S Hoover Rd W22, Wichita, KS 67215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-82f2-708d-b371-84caf98c37cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-82f2-708d-b371-84caf98c37cf",
        "storage_key": "property/6767906449166543/019cfb4e-82f2-708d-b371-84caf98c37cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.txtav.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3817218495772905269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c6",
      "poi_latitude": "37.6483078",
      "poi_longitude": "-97.4184875",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-517-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxff2E9jnuocRNU-YVv97-TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d91ed625-baff-4a5f-911a-1b5b762d2aea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "John Deere Wichita Training Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2256 S West St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-82dd-72f5-bbe3-ce32ec4f70a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-82dd-72f5-bbe3-ce32ec4f70a5",
        "storage_key": "property/6767906449166543/019cfb4e-82dd-72f5-bbe3-ce32ec4f70a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=688762764425094815&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-deere-wichita-training-center",
      "poi_latitude": "37.6533633",
      "poi_longitude": "-97.38795650000002",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-440-4317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYbK069DmuocRn-YSxBX6jgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3f446c3c-4e20-46b2-aeb4-432155d40459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wichita Airport Authority",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2173 S Air Cargo Rd, Wichita, KS 67209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8327-71aa-b261-18d57f29e631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8327-71aa-b261-18d57f29e631",
        "storage_key": "property/6767906449166543/019cfb4e-8327-71aa-b261-18d57f29e631.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flywichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12065485111422522274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-airport-authority",
      "poi_latitude": "37.6556663",
      "poi_longitude": "-97.4330832",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-946-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0QnDVHnuocRopMafcg2cac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d60ac032-600c-47f6-8941-22d48d15a06d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "McCollom Elementary School",
      "poi_type": "Education",
      "poi_address": "1201 N Waddington Ave, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mccollom.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10687023352772072394&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mccollom-elementary-school",
      "poi_latitude": "37.7042375",
      "poi_longitude": "-97.4501715",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-973-0350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7djf9LfuocRypNI-B3vT5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_97d308a7-8894-4951-bf78-90741ce4dff8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Benton Elementary School",
      "poi_type": "Education",
      "poi_address": "338 S Woodchuck Ln, Wichita, KS 67209, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-b51e-71d2-97ba-3af828259547.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b51e-71d2-97ba-3af828259547",
        "storage_key": "property/6767906449166543/019d7915-b51e-71d2-97ba-3af828259547.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://benton.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14596827611304694218&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "benton-elementary-school",
      "poi_latitude": "37.678518",
      "poi_longitude": "-97.4344978",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-973-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx6RXnqHguocRyhFuC2BZkso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_40eb9e24-d281-4804-93a0-ab180f8ff61f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wichita Friends School",
      "poi_type": "Education",
      "poi_address": "14700 US-54, Wichita, KS 67235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-b34a-753d-b185-9d7b6b87c642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b34a-753d-b185-9d7b6b87c642",
        "storage_key": "property/6767906449166543/019d7915-b34a-753d-b185-9d7b6b87c642.webp",
        "width": 1122,
        "height": 748
      },
      "poi_business_url": "http://wichitafriendsschool.org/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=15729681950071557977",
      "poi_directions_map_url": "https://maps.google.com/?cid=15541231450749871466&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-friends-school",
      "poi_latitude": "37.6648055",
      "poi_longitude": "-97.5109265",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-729-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhbWDvKTeuocRaiUT2qmLrdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_bc226a4b-8de8-4bab-bc56-c92a361467bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wilbur Middle School",
      "poi_type": "Education",
      "poi_address": "340 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-b249-72fa-ad51-5c8017c42f80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b249-72fa-ad51-5c8017c42f80",
        "storage_key": "property/6767906449166543/019d7915-b249-72fa-ad51-5c8017c42f80.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://wilbur.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15968973275339850066&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wilbur-middle-school",
      "poi_latitude": "37.688307",
      "poi_longitude": "-97.442531",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-973-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSQPgYybeuocRUoFWMJYwnd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c63b133b-c238-4d7e-be73-087e354aba2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wichita Northwest High School",
      "poi_type": "Education",
      "poi_address": "1220 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-b37e-70bf-a851-e2cd0d804627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b37e-70bf-a851-e2cd0d804627",
        "storage_key": "property/6767906449166543/019d7915-b37e-70bf-a851-e2cd0d804627.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://northwest.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11315080650523255213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-northwest-high-school",
      "poi_latitude": "37.70475589999999",
      "poi_longitude": "-97.440365",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-973-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKdEivNXfuocRraFV2-Y9B50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_32f09c5c-f41e-4753-8197-e19b8c7a1e63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Bishop Carroll Catholic High School",
      "poi_type": "Education",
      "poi_address": "8101 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-b927-7248-909a-648738d42dff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b927-7248-909a-648738d42dff",
        "storage_key": "property/6767906449166543/019d7915-b927-7248-909a-648738d42dff.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://bcchs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6469757000547285599&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bishop-carroll-catholic-high-school",
      "poi_latitude": "37.6933278",
      "poi_longitude": "-97.4365556",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 316-722-2390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUgtmoLguocRX7q3uLYxyVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a16a6491-7fb0-4c12-b52f-a9a83aac0b5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "St. Francis of Assisi Catholic School",
      "poi_type": "Education",
      "poi_address": "853 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stfranciswichita.com/index.php/school",
      "poi_directions_map_url": "https://maps.google.com/?cid=11799891258123803907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "st-francis-of-assisi-catholic-school",
      "poi_latitude": "37.6971551",
      "poi_longitude": "-97.4388012",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-722-5171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrQ2sPSreuocRA920rJSiwaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fa56be8b-b94c-4ed4-b888-ede6fa086d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "WSU Tech - City Center",
      "poi_type": "Education",
      "poi_address": "301 S Grove St, Wichita, KS 67211, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-b982-70ac-acf8-97c2fb502835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b982-70ac-acf8-97c2fb502835",
        "storage_key": "property/6767906449166543/019d7915-b982-70ac-acf8-97c2fb502835.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wsutech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13397923867905285235&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wsu-tech-city-center",
      "poi_latitude": "37.6822022",
      "poi_longitude": "-97.3093214",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-677-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ1WB7p3juocRc9w4ysX87rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_7f582b56-b927-4a26-b314-ef3d952efac4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-c521-7037-8974-41332940f275.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c521-7037-8974-41332940f275",
        "storage_key": "property/6767906449166543/019d7915-c521-7037-8974-41332940f275.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8718-703d-9146-b9715730d790",
        "storage_key": "property/6767906449166543/019cfb4e-8718-703d-9146-b9715730d790.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a112cacc-95ab-4279-8dc5-f70b6b3f7e8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "The Sweet Spot Restaurant & Lounge",
      "poi_type": "Restaurants",
      "poi_address": "7703 E Douglas Ave, Wichita, KS 67207, USA",
      "poi_short_description": "Relaxed spot for steak and seafood, plus other American favorites, cocktails and wine.",
      "poi_long_description": "People say this American restaurant serves delicious food, including calamari, pork chops, and salmon. They also highlight the great patio vibe, attentive staff, and the chef's personal touch.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-c64b-7241-a612-7df59ead2f1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c64b-7241-a612-7df59ead2f1b",
        "storage_key": "property/6767906449166543/019d7915-c64b-7241-a612-7df59ead2f1b.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://wichitasweetspot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6580862354361357816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-sweet-spot-restaurant-lounge",
      "poi_latitude": "37.6858363",
      "poi_longitude": "-97.2486109",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-260-4999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7BcokvfuocR-BVzw3HrU1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0eb1a511-15ec-4254-b6a2-b1b3984cc84f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Fazoli's",
      "poi_type": "Restaurants",
      "poi_address": "8520 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Fast-food chain doling out baked pastas, subs, pizza & other casual Italian fare plus custom combos.",
      "poi_long_description": "People say this restaurant serves delicious pasta, chicken parm, and ziti with sausage. They also highlight the fast, friendly, and attentive service, and the clean and calm atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-ca7e-71e1-a6b7-5356d88676c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ca7e-71e1-a6b7-5356d88676c6",
        "storage_key": "property/6767906449166543/019d7915-ca7e-71e1-a6b7-5356d88676c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fazolis.com/stores/ks-wichita-8520-west-central-avenue-67212-2/?utm_source=yext+GMB&utm_medium=local&utm_campaign=website&y_source=1_MzExNzEzOS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11258088599120775&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fazoli-s",
      "poi_latitude": "37.694707",
      "poi_longitude": "-97.4414149",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-721-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKREdDSneuocRh-vMAyz_JwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1e6fb74a-8d99-4655-9fd9-00d03cc897b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Spangles",
      "poi_type": "Restaurants",
      "poi_address": "612 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Regional fast-food chain offering burgers, sandwiches, fries, ice cream & breakfast items.",
      "poi_long_description": "Diners say this fast food restaurant serves delicious burgers and fries, especially the garlic parm burger and fries with garlic parm seasoning. They also highlight the friendly staff and clean dining area.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-c734-700e-9405-b949056a6e85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c734-700e-9405-b949056a6e85",
        "storage_key": "property/6767906449166543/019d7915-c734-700e-9405-b949056a6e85.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.spanglesinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13623777411834297823&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spangles",
      "poi_latitude": "37.6931865",
      "poi_longitude": "-97.4440261",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-721-1769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7e_3KS_euocR371fy19hEb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6ec99bbc-4cd2-44af-a882-211fe66c1a3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "10515 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-d0b1-7488-8250-7ed875dbf52e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d0b1-7488-8250-7ed875dbf52e",
        "storage_key": "property/6767906449166543/019d7915-d0b1-7488-8250-7ed875dbf52e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/6859",
      "poi_directions_map_url": "https://maps.google.com/?cid=13292659355058972112&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "37.69268",
      "poi_longitude": "-97.46433",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-729-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7916-0650-77fe-8523-7d4092585be8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-0650-77fe-8523-7d4092585be8",
        "storage_key": "property/6767906449166543/019d7916-0650-77fe-8523-7d4092585be8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJx0EnO0neuocR0CWQgkEDebg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1799a199-db06-4e31-a434-5507bc194e3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Smoothie King",
      "poi_type": "Restaurants",
      "poi_address": "8000 W Central Ave Ste 500, Wichita, KS 67212, USA",
      "poi_short_description": "Health-conscious chain featuring blended drinks in varied flavors with fruits & veggies.",
      "poi_long_description": "People say this juice shop offers delicious smoothies, acai bowls, and avocado toast. They also highlight the friendly and helpful service, and the clean and welcoming atmosphere.\n\nSome reviews mention the exit can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-d63a-700a-8e66-05cfea5a55b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d63a-700a-8e66-05cfea5a55b3",
        "storage_key": "property/6767906449166543/019d7915-d63a-700a-8e66-05cfea5a55b3.webp",
        "width": 1280,
        "height": 839
      },
      "poi_business_url": "https://locations.smoothieking.com/ll/us/ks/wichita/8000-w-central--ste-500/?utm_source=google&utm_medium=organic&utm_content=SOCi",
      "poi_directions_map_url": "https://maps.google.com/?cid=11530434790299722149&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smoothie-king",
      "poi_latitude": "37.6946216",
      "poi_longitude": "-97.4358035",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 316-721-7942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-2_eYLguocRpeGe1VlVBKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_503af953-4c90-4f5e-9bd3-0c9191b246c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Pho Cao",
      "poi_type": "Restaurants",
      "poi_address": "9203 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Casual restaurant serving Vietnamese specialties, including pho and spring rolls.",
      "poi_long_description": "People say this restaurant serves delicious pho, spring rolls, and other Vietnamese dishes. They highlight the flavorful broth, generous portions, and reasonable prices. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-d961-733b-adcd-65886cc92027.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d961-733b-adcd-65886cc92027",
        "storage_key": "property/6767906449166543/019d7915-d961-733b-adcd-65886cc92027.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Pho-Cao-370906050136785/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8031243564882518012&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pho-cao",
      "poi_latitude": "37.6935924",
      "poi_longitude": "-97.4500186",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-369-8554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpaiQPFXfuocR_N92jXi1dG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_89f9d93b-541e-4ef7-8d9a-bc3aecd605a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Bella Vita Bistro",
      "poi_type": "Restaurants",
      "poi_address": "9506 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Traditional & inventive Italian dishes in a charming villalike atmosphere with a full bar.",
      "poi_long_description": "People say this Italian restaurant serves delicious dishes, including gluten-free options, and offers a variety of pasta, seafood, and meat entrees. They highlight the reasonable prices, cozy and romantic atmosphere, and attentive service. They also like the fresh bread and oil served at the beginning of the meal.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-d94a-71ee-9b89-0b69d7008700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d94a-71ee-9b89-0b69d7008700",
        "storage_key": "property/6767906449166543/019d7915-d94a-71ee-9b89-0b69d7008700.webp",
        "width": 1000,
        "height": 662
      },
      "poi_business_url": "https://www.facebook.com/share/1AMZ6MbMsH/?mibextid=wwXIfr",
      "poi_directions_map_url": "https://maps.google.com/?cid=15651444174799193471&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bella-vita-bistro",
      "poi_latitude": "37.694472",
      "poi_longitude": "-97.452728",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-941-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-871e-73bd-bf5d-74650a0615e8",
        "storage_key": "property/6767906449166543/019cfb4e-871e-73bd-bf5d-74650a0615e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWISxhjhuocRf0XDVI0ZNdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_df1594a9-d202-44ee-87e0-ffccb3cec866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Jerry's Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "630 N Robin Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Music-focused bar offering weekend bands, drink specials & burgers & other bar eats in unfussy eats.",
      "poi_long_description": "People say this bar and grill offers delicious food, including fish and chips, and features live music with a dance floor. They also highlight the friendly staff and cold, crisp drinks.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-df98-778e-a92b-89c106cbd779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-df98-778e-a92b-89c106cbd779",
        "storage_key": "property/6767906449166543/019d7915-df98-778e-a92b-89c106cbd779.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/JerrysBarandGrill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11959506695766938040&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jerry-s-bar-grill",
      "poi_latitude": "37.69310710000001",
      "poi_longitude": "-97.4415588",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 316-358-9201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7916-06a6-76e9-9e99-51ae3f6b4f51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-06a6-76e9-9e99-51ae3f6b4f51",
        "storage_key": "property/6767906449166543/019d7916-06a6-76e9-9e99-51ae3f6b4f51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeqP4yjeuocRuBEYwvmz-KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_1069bcb5-884d-456c-bd1a-233e981dacb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Sunflour Cafe & Collective",
      "poi_type": "Restaurants",
      "poi_address": "6120 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Coffee, tea and other drinks are served up here alongside a range of eats from breakfast dishes to pizzas and salads.",
      "poi_long_description": "People say this cafe offers delicious vegan and gluten-free options, including breakfast, wraps, and treats. They highlight the cozy, mom-and-pop vibe, and the unique collection of local art and handmade items. They also like the friendly and accommodating staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-e3bf-775e-85b1-323e6b990699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e3bf-775e-85b1-323e6b990699",
        "storage_key": "property/6767906449166543/019d7915-e3bf-775e-85b1-323e6b990699.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680928216022015608&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunflour-cafe-collective",
      "poi_latitude": "37.6948242",
      "poi_longitude": "-97.4141387",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-768-7898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7916-0650-77fe-8523-7d4092585be8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-0650-77fe-8523-7d4092585be8",
        "storage_key": "property/6767906449166543/019d7916-0650-77fe-8523-7d4092585be8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJI-MOK8fhuocReF7UAlP-GqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_5012d47c-b050-4589-b6f3-40d0b5f7ee53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "8951 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-e3d9-77de-b7c7-2da51469af91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e3d9-77de-b7c7-2da51469af91",
        "storage_key": "property/6767906449166543/019d7915-e3d9-77de-b7c7-2da51469af91.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ks/wichita/2736",
      "poi_directions_map_url": "https://maps.google.com/?cid=15665307373149436829&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "37.6926957",
      "poi_longitude": "-97.446673",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-223-7858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8y6tAC_euocRnTvhuQ5aZtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_db31ed7b-d10f-47d8-9cb9-e66f0af1737a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7575 W Maple St, Wichita, KS 67209, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-ed5f-7310-9fb5-a61ef4d43ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ed5f-7310-9fb5-a61ef4d43ecf",
        "storage_key": "property/6767906449166543/019d7915-ed5f-7310-9fb5-a61ef4d43ecf.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/wichita-maple/1943",
      "poi_directions_map_url": "https://maps.google.com/?cid=223850493551422223&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.6776535",
      "poi_longitude": "-97.4318823",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-729-5348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjS_TGaLguocRD6vtftZGGwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ab66a38e-1b38-4936-a7b4-f8c8b6ce6a38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Towne West Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "4600 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Traditional indoor shopping mall featuring a range of stores, several casual eateries & a cinema.",
      "poi_long_description": "People say this shopping center offers a movie theater and a Dillard's Clearance Store with big discounts on brand names.\n\nOther reviews mention the mall can be abandoned and many stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-ed96-717d-93fe-bd918dd36f2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ed96-717d-93fe-bd918dd36f2c",
        "storage_key": "property/6767906449166543/019d7915-ed96-717d-93fe-bd918dd36f2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://townewestsquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=668552573609541603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "towne-west-square",
      "poi_latitude": "37.6778456",
      "poi_longitude": "-97.3999493",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-945-1236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOS9HONnguocR43-rBwYtRwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_339311ae-b0ea-49e8-a89b-d8e7f9098948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "6700-6820 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-f2b7-7506-8c0a-9b8fa240c817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f2b7-7506-8c0a-9b8fa240c817",
        "storage_key": "property/6767906449166543/019d7915-f2b7-7506-8c0a-9b8fa240c817.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5215421891585969296&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-j-maxx",
      "poi_latitude": "37.6751323",
      "poi_longitude": "-97.4212545",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-943-2055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF83OarnguocRkAzH8ZPmYEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ff86bc94-59b9-4d3f-988e-0b00a672d7a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Boot Barn",
      "poi_type": "Shopping & Retail",
      "poi_address": "6501 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Retail chain with a variety of Western & work-related apparel, shoes & accessories, plus gifts.",
      "poi_long_description": "People say this boot store offers a wide selection of boots, jackets, and other apparel. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-f4bc-700b-a8c3-1db13f822ed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f4bc-700b-a8c3-1db13f822ed7",
        "storage_key": "property/6767906449166543/019d7915-f4bc-700b-a8c3-1db13f822ed7.webp",
        "width": 1088,
        "height": 611
      },
      "poi_business_url": "https://www.bootbarn.com/stores?StoreID=0301",
      "poi_directions_map_url": "https://maps.google.com/?cid=16475904469878882310&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boot-barn",
      "poi_latitude": "37.6719182",
      "poi_longitude": "-97.417369",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-946-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-8729-7244-aef0-01811768718f",
        "storage_key": "property/6767906449166543/019cfb4e-8729-7244-aef0-01811768718f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvcAIErjguocRBsBmgNIrpuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_f4f31cec-624c-437d-9e14-edfd63c1c179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Carousel Skate Center",
      "poi_type": "Entertainment",
      "poi_address": "312 N West St, Wichita, KS 67203, USA",
      "poi_short_description": "This family-owned roller-skating rink with a shop is available for parties.",
      "poi_long_description": "People say this amusement center offers a fun skating rink, arcade games, and a jungle gym. They highlight the affordable prices, especially during summer discounts, and the family-friendly atmosphere. They also like the friendly and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-f919-7029-872d-89392defeb07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f919-7029-872d-89392defeb07",
        "storage_key": "property/6767906449166543/019d7915-f919-7029-872d-89392defeb07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carouselsk8ks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16541990297131856275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carousel-skate-center",
      "poi_latitude": "37.6884778",
      "poi_longitude": "-97.3887395",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-942-4505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4e-872a-76ce-9d18-7acd42dc57f6",
        "storage_key": "property/6767906449166543/019cfb4e-872a-76ce-9d18-7acd42dc57f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1KtXhnhuocRk7GAMoj0kOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_b2bcedd8-a7aa-48c5-9c3d-fc81371ea181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "Regal Warren West",
      "poi_type": "Entertainment",
      "poi_address": "9150 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "People say this movie theater offers a variety of films, including IMAX and Screen X options. They also highlight the comfortable seats, clean facilities, and friendly staff.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7915-f946-7662-9dd7-f7d69810b6f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f946-7662-9dd7-f7d69810b6f1",
        "storage_key": "property/6767906449166543/019d7915-f946-7662-9dd7-f7d69810b6f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-west-1443?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3042760775773274275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-warren-west",
      "poi_latitude": "37.724285",
      "poi_longitude": "-97.44779",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d7916-07b9-712e-bbe9-cdccf1b18663.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-07b9-712e-bbe9-cdccf1b18663",
        "storage_key": "property/6767906449166543/019d7916-07b9-712e-bbe9-cdccf1b18663.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXKGy-ffuocRo0B16M0OOio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a7b1f0a5-864c-44b3-8c50-afa0b56be55c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "poi_name": "JOANN Fabric and Crafts",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "joann-fabric-and-crafts",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_555567eea2fe796ae2b29af9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3a60e5454de5bfb783f236a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_094dee8a1bfb4276431e1ca9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0f5bcde418d632bea0f82ad9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_d3d6e1026a223f48c460aa8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_e1ce26743d3f60f6b9dcba9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_d54b091b-3c1f-4564-b55b-5b9874ea8d12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "rating": "5.0",
      "name": "Bwana Villa",
      "text": "I have lived here since 2019. The staff are amazing.  When I say staff I mean it in its entirety. From day one it has been a great experience from communication, to tour, to moving into a spotless apartment with new carpet. The maintenance team is extremely prompt and courteous. Case is also great at keeping the property upgraded and updated. If issues arise they do not hesitate to take action even if it cost money to make it better. Examples, new clean secure laundry facilities, new spacious concrete porches, new parking lot resurfacing and retainer walls, pool repairs, apartment updates, 24 hr security, the list goes on and on. The only negative experience I have ever had (going boomer on ya) was due to the secret getting out about this place in the last few years and the newer neighbors being a little less respectful of keeping the property clean of trash, animal waste and furniture dumping, but guess what?  They work hard to combat that as well. Just pick up the phone and they are on it. Whatever the opposite of a slum lord is that's what these folks are.  I give them 2 thumbs up, 11 out of 10. I's gonna be hard to move out 😩.",
      "date": "2025-09-11",
      "title": ""
    },
    {
      "id": "custom_ee7b8c0f-d4c3-470d-a637-f728dbaefc7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "rating": "5.0",
      "name": "Winter IsPretty",
      "text": "I was able to move in 2 days and had only small issues with the apartment. I filled out a sheet of anything I noticed, and they said they would fix the issues. I really needed a different place to live that had more amenities, and this was one of the options. I was thrown off by the lack of reviews, but they do tours any time, so that was what made the ultimate decision when I saw this place. They don't have built-in washer units for my place, but they have units connected to the office that are $2 per cycle, which connect via an app. There are a lot of birds that chirp, which adds to the atmosphere since it isn't only grackles or starlings that sound ugly. There are house sparrows and finches, robins, and other birds, which make it more neighborly. I think this place looks very nice and it seems the people living here are friendly but it is smoke friendly so you will be able to see people smoking on their patio. All units have dishwashers, which is a HUGE plus, and my bathroom has a fan, which helps prevent mold. I have a small walk-in closet, but that alone can store a ton of clothing plus 2 more small closets. The bedroom is a very good size and makes it more comfy. I was able to fit the giant couch that I couldn't fit in the previous apartment. The A/C is decently quiet, and I am a very light sleeper, so I needed that. I also like that there is a carpet. My place is on the floor, and it seems the upstairs isn't too squeeky, which is also good. There are a ton of cars parked, so it can be difficult to park sometimes, though. I noticed that all the noticeable steps are painted yellow. Sometimes, there is the occasional plane flying close by. All of this is worth the price I pay for rent, and I hope to live here for as long as I need to. Shoutout to Josh at the office.",
      "date": "2025-06-10",
      "title": ""
    },
    {
      "id": "custom_d814d9ac-3f35-4dd0-ad77-4275d75b5f5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "rating": "5.0",
      "name": "Dani Higgins",
      "text": "I just renewed my lease for the 3rd year and I love it! The staff actually takes their time to get to know you as a person, not just an apartment number. It's affordable and they are quick to fix any issue, even light bulbs! Location is great, too. Close to gas stations, food, grocery stores, and very easy to get on highways. Highly recommend Aspen Park!",
      "date": "2025-06-19",
      "title": ""
    },
    {
      "id": "custom_5651970f-5cca-496c-93ff-6951448ea137",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "rating": "5.0",
      "name": "Leonna Greenfeather",
      "text": "I love it here! I have formed a community within our community. I interact with my neighbors and know them by name. We care about each other. Erin, Josh, and Zoey in the office are never to busy to chat or take care of any needs. Chad, Kevin, Marilyn, and the rest of maintenance and housekeeping are a joy and quick to share a smile, or taste test something I made in the kitchen. Thank you for being my \"Home\"!",
      "date": "2025-08-31",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ce1ebf67-4bf1-4ddd-897a-a873fe1e9450",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4f-2cd4-72db-a372-d568cce5a141.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the outdoor swimming pool and surrounding lounge area.",
        "public_id": "019cfb4f-2cd4-72db-a372-d568cce5a141",
        "storage_key": "property/6767906449166543/019cfb4f-2cd4-72db-a372-d568cce5a141.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Aspen Park Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f43f12476f57c46b434a760"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b2-8927-7266-8701-44364e98ecb5",
      "lead_source": "LANDING_PAGE",
      "name": "case-aspen-park-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543"
    },
    {
      "lead_collector_id": "019cf79d-32fe-7408-9879-a9e7a75ca49b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aspen-park-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "apartments-with-pool-wichita-ks",
      "search_query": "apartments with pool in Wichita KS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Wichita KS",
      "h2_subtitle": "Looking for apartments with a pool in Wichita, KS? Aspen Park offers resort-style amenities including a stunning pool and much more.",
      "page_copy": "Discover the perfect balance of comfort and luxury at Aspen Park, where we proudly feature apartments with pool in Wichita KS. Whether you're a sunbather or a swimmer, our refreshing resort-style pool is a community highlight, perfect for unwinding on warm Kansas days. Our residents enjoy lounging on the sun-drenched sundeck before taking a serene dip, creating an idyllic retreat right at home.\n\nIn addition to our standout pool, Aspen Park offers an array of amenities designed to elevate your living experience. With a fully-equipped fitness center, inviting clubhouse, and well-maintained tennis courts, you'll have plenty of options for leisure and recreation. Nestled in West Wichita, our location offers convenient access to shopping, dining, and more, making Aspen Park an ideal choice for those seeking apartments with pool in Wichita KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Wichita KS | Aspen Park",
      "seo_description": "Discover Aspen Park in Wichita, KS—luxury apartments with a pool, fitness center, and more, offering the ultimate in resort-style living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "aspen-park-fitness-center-apartments",
      "search_query": "Aspen Park fitness center apartments",
      "category": "Amenity",
      "h1_title": "Aspen Park Fitness Center Apartments",
      "h2_subtitle": "Discover Aspen Park, where fitness center apartments provide residents with top-of-the-line facilities in Wichita, KS.",
      "page_copy": "At Aspen Park, we understand the importance of a healthy lifestyle. That's why we offer top-tier fitness center apartments to our residents. Located in West Wichita, our state-of-the-art fitness center ensures that you can focus on your well-being right at home. Whether you prefer a morning workout or an evening session, our fitness facilities are designed to fit your schedule and help you reach your goals.\n\nIn addition to our on-site fitness center, Aspen Park residents enjoy a range of deluxe amenities. From cozy fireplaces and business centers to tennis courts and a refreshing swimming pool, everything you need is right at your doorstep. Our community offers a serene yet dynamic living environment, providing a perfect blend of relaxation and activity. Embrace the vibrant lifestyle at Aspen Park, your destination for fitness center apartments in Wichita, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Aspen Park Fitness Center Apartments",
      "seo_description": "Explore Aspen Park's fitness center apartments in Wichita, KS. Enjoy state-of-the-art facilities, a swimming pool, and more for a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-west-wichita",
      "search_query": "air conditioned apartments West Wichita",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in West Wichita",
      "h2_subtitle": "Experience comfort at Aspen Park with our air conditioned apartments in West Wichita. Find your perfect home today.",
      "page_copy": "Living in West Wichita has never been more comfortable than at Aspen Park. Our air conditioned apartments offer you a cool, refreshing retreat from the Kansas summer heat. Designed for comfort and convenience, these apartments ensure you can always relax in a climate that's perfect for you. Enjoy spacious living areas that maintain ideal temperatures all year round.\n\nBeyond air conditioning, Aspen Park elevates your lifestyle with a host of other amenities. Residents can unwind in the luxury of our resort-style pool, keep fit in our state-of-the-art fitness center, and connect with fellow community members in our inviting clubhouse. Located conveniently in West Wichita, you'll find shopping, dining, and entertainment options are just a stone's throw away. Choose Aspen Park's air conditioned apartments in West Wichita for comfort and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in West Wichita",
      "seo_description": "Discover Aspen Park's air conditioned apartments in West Wichita. Enjoy year-round comfort with state-of-the-art amenities nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "apartments-with-tennis-court-sedgwick-county",
      "search_query": "apartments with tennis court Sedgwick County",
      "category": "Amenity",
      "h1_title": "Apartments with Tennis Court in Sedgwick County",
      "h2_subtitle": "Aspen Park features premier apartments with a tennis court in Sedgwick County, perfect for sports enthusiasts and those seeking an active lifestyle.",
      "page_copy": "Aspen Park is your destination for apartments with a tennis court in Sedgwick County. Perfect for tennis lovers, our well-maintained courts offer the ideal venue to hone your skills or simply enjoy a casual match with friends. Spending time on our courts is just one of the many ways our community promotes an active and engaging lifestyle.\n\nAlongside our fantastic tennis facilities, Aspen Park provides a variety of other premium amenities. Cool off in our resort-style swimming pool, stay fit with our modern fitness center, or relax in the comfortable ambiance of our clubhouse. Located in the heart of Sedgwick County, our community provides easy access to local dining spots, shopping centers, and entertainment venues. Choose Aspen Park for an enriched living experience with unmatched recreational options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Tennis Court in Sedgwick County",
      "seo_description": "Explore Aspen Park's apartments with a tennis court in Sedgwick County. Enjoy top amenities and active living in this vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "clubhouse-apartments-west-wichita",
      "search_query": "clubhouse apartments in West Wichita",
      "category": "Amenity",
      "h1_title": "Clubhouse Apartments in West Wichita",
      "h2_subtitle": "Aspen Park offers clubhouse apartments in West Wichita, providing a perfect blend of community and comfort with modern amenities.",
      "page_copy": "Discover the joys of living at Aspen Park, where our clubhouse apartments in West Wichita offer residents an engaging and welcoming environment. Our inviting clubhouse is the heart of the community, providing a space where neighbors can connect, unwind, and enjoy various activities. Whether you're hosting a gathering or meeting friends for a casual chat, our clubhouse is the ideal setting.\n\nAt Aspen Park, we prioritize a balanced lifestyle with a suite of top-tier amenities. Residents can enjoy the refreshing swimming pool, work out in the fitness center, or take advantage of the business center. Nestled in vibrant West Wichita, our community offers convenient access to shopping, dining, and entertainment. Experience the best of clubhouse apartments in West Wichita at Aspen Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse Apartments in West Wichita",
      "seo_description": "Explore Aspen Park's clubhouse apartments in West Wichita. Enjoy community amenities like our inviting clubhouse, fitness center, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "studio-apartments-west-wichita",
      "search_query": "studio apartments west wichita",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in West Wichita",
      "h2_subtitle": "Aspen Park offers ideal studio apartments in West Wichita, perfect for individuals seeking a cozy and efficient living space.",
      "page_copy": "Aspen Park proudly presents our charming studio apartments in West Wichita, designed for those who appreciate a minimalist lifestyle without sacrificing comfort. These well-designed spaces provide everything you need, ensuring each studio is a tranquil haven just right for singles or professionals on the go. Each apartment is thoughtfully crafted to maximize functionality and style.\n\nLocated in the lively West Wichita, Aspen Park offers more than just a place to live. Residents benefit from a suite of luxury amenities, including a refreshing pool, contemporary fitness center, and community clubhouse. Whether you prefer to relax in the outdoors or enjoy local attractions, our strategic location provides easy access to shopping, dining, and entertainment options. Embrace efficient living at its best with our studio apartments in West Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in West Wichita",
      "seo_description": "Explore Aspen Park's studio apartments in West Wichita. Ideal for a cozy lifestyle, featuring modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-sedgwick-county",
      "search_query": "one bedroom apartments sedgwick county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Sedgwick County",
      "h2_subtitle": "Aspen Park features spacious one bedroom apartments in Sedgwick County, designed for comfort and modern living.",
      "page_copy": "Aspen Park invites you to explore our one bedroom apartments in Sedgwick County, where style meets function. Each apartment is designed with your comfort in mind, offering ample living space and modern amenities that make it a perfect place for singles or couples. From the cozy fireplace to the elegant design, these apartments provide a warm and inviting living experience.\n\nSet in the vibrant Sedgwick County, Aspen Park offers more than just a beautiful residence—it's a community. Enjoy resort-style amenities such as our sparkling swimming pool, state-of-the-art fitness center, and a welcoming clubhouse. Located conveniently, our community provides easy access to the best of Sedgwick County’s dining, shopping, and entertainment. Experience a balanced lifestyle in our one bedroom apartments at Aspen Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Sedgwick County",
      "seo_description": "Discover Aspen Park's one bedroom apartments in Sedgwick County. Enjoy spacious living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-wichita-ks",
      "search_query": "two bedroom apartments wichita ks",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Wichita, KS",
      "h2_subtitle": "Aspen Park offers well-appointed two bedroom apartments in Wichita, KS, perfect for modern living with abundant amenities.",
      "page_copy": "At Aspen Park, our two bedroom apartments in Wichita, KS offer the ideal mix of space and modern conveniences, tailor-made for families or roommates seeking a comfortable yet stylish home. These apartments provide plenty of space, featuring key amenities such as a cozy fireplace and contemporary designs, all contributing to a sophisticated living experience.\n\nOur residents enjoy a community with top-notch amenities, including a refreshing pool, fitness center, and a vibrant clubhouse, making everyday living both relaxed and engaging. Nestled in Wichita, KS, Aspen Park ensures you're close to a variety of shopping, dining, and entertainment options, making urban convenience a part of everyday life. Experience the charm and warmth of our two bedroom apartments and make Aspen Park your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Wichita, KS",
      "seo_description": "Discover Aspen Park's spacious two bedroom apartments in Wichita, KS. Experience modern living with exceptional amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "apartments-near-friends-university-wichita",
      "search_query": "apartments near Friends University Wichita",
      "category": "School",
      "h1_title": "Apartments Near Friends University, Wichita",
      "h2_subtitle": "Aspen Park offers contemporary apartments near Friends University, Wichita, providing convenience and comfort for students and professionals alike.",
      "page_copy": "Aspen Park presents the perfect blend of location and lifestyle with our apartments near Friends University in Wichita. Ideal for students and professionals, our community offers modern living spaces just minutes away from the campus. Our thoughtfully designed apartments ensure you have a comfortable space to study and unwind, complete with stylish amenities to enhance your living experience.\n\nLocated in West Wichita, Aspen Park residents can take advantage of various on-site amenities, such as a fitness center, swimming pool, and business center, facilitating a balanced lifestyle between work and play. With the university nearby, along with easy access to local dining and entertainment, everything you need is right at your doorstep. Choose Aspen Park for proximity and convenience near Friends University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Friends University, Wichita",
      "seo_description": "Find ideal apartments near Friends University, Wichita at Aspen Park. Enjoy modern amenities and a convenient location for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "apartments-close-to-newman-university-sedgwick-county",
      "search_query": "apartments close to Newman University Sedgwick County",
      "category": "School",
      "h1_title": "Apartments Close to Newman University",
      "h2_subtitle": "Discover Aspen Park's apartments close to Newman University, situated in Sedgwick County for convenient student living.",
      "page_copy": "At Aspen Park, discover the perfect home with our apartments close to Newman University in Sedgwick County. Our location offers students an ideal and convenient living experience, balancing academic and social life. Each apartment is designed with quality and comfort in mind, making it an excellent choice for students seeking a home that supports their university journey.\n\nOur community offers an array of amenities, including a fitness center, swimming pool, and inviting clubhouse, creating an atmosphere where you can thrive both academically and personally. With Newman University just a short commute away and local shopping, dining, and entertainment options easily accessible, Aspen Park provides everything needed for a holistic student experience right in Sedgwick County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Newman University",
      "seo_description": "Explore Aspen Park's apartments close to Newman University. Located in Sedgwick County, enjoy convenience and community amenities perfect for students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-via-christi-st-francis-wichita",
      "search_query": "apartments near ascension via christi st francis wichita",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension Via Christi, Wichita",
      "h2_subtitle": "Aspen Park offers convenient living with apartments near Ascension Via Christi St. Francis in Wichita, ideal for healthcare professionals.",
      "page_copy": "Located in Wichita, Aspen Park provides a perfect housing solution with our apartments near Ascension Via Christi St. Francis. Tailored for healthcare professionals and anyone seeking proximity to this reputable medical center, our community boasts modern amenities and a welcoming atmosphere that makes coming home a pleasure.\n\nResidents at Aspen Park enjoy easy access to their daily needs while living in a vibrant community. With features like a relaxing swimming pool, fully-equipped fitness center, and a professional business center, it’s effortless to maintain a balanced lifestyle. Being near Ascension Via Christi St. Francis, our apartments offer not only convenience but also a peaceful retreat after busy workdays. Experience comfortable living at Aspen Park in Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension Via Christi, Wichita",
      "seo_description": "Discover Aspen Park's well-located apartments near Ascension Via Christi St. Francis in Wichita, offering comfort and amenities for healthcare workers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-via-christi-st-teresa-west-wichita",
      "search_query": "apartments close to ascension via christi st teresa west wichita",
      "category": "Hospital",
      "h1_title": "Apartments Close to Ascension Via Christi St. Teresa",
      "h2_subtitle": "Aspen Park's apartments are located conveniently close to Ascension Via Christi St. Teresa in West Wichita, perfect for healthcare staff and patients.",
      "page_copy": "Aspen Park offers an ideal living solution with apartments close to Ascension Via Christi St. Teresa in West Wichita. Perfect for healthcare professionals or patients seeking nearby housing, our community provides easy access and a comfortable environment. Enjoy the convenience of modern living just moments from this respected hospital.\n\nResidents of Aspen Park benefit from a range of amenities designed to enhance daily life. With features like a refreshing pool, fitness center, and inviting clubhouse, relaxation and wellness are within reach. Being strategically located in West Wichita, near Ascension Via Christi St. Teresa, you’ll appreciate the seamless commute and the vibrant community atmosphere we offer, making Aspen Park an excellent choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ascension Via Christi St. Teresa",
      "seo_description": "Explore Aspen Park’s apartments close to Ascension Via Christi St. Teresa in West Wichita, ideal for healthcare professionals and patients looking for comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "apartments-near-botanica-the-wichita-gardens",
      "search_query": "apartments near Botanica The Wichita Gardens KS",
      "category": "Park",
      "h1_title": "Apartments Near Botanica The Wichita Gardens",
      "h2_subtitle": "Discover Aspen Park's convenient apartments near Botanica The Wichita Gardens, KS, offering lush beauty and vibrant living.",
      "page_copy": "Aspen Park features charming apartments near Botanica The Wichita Gardens, KS, making them the perfect choice for nature lovers and those who enjoy a serene environment. Nestled in Wichita, our community combines convenient city living with close proximity to one of the area's most beautiful attractions, offering residents a tranquil retreat surrounded by lush greenery.\n\nOur residents enjoy a host of amenities, including a fitness center, sparkling pool, and a vibrant clubhouse. With Botanica The Wichita Gardens just a short drive away, leisure and outdoor adventures are at your doorstep. Aspen Park embodies a harmonious blend of comfort and lifestyle, ideal for anyone looking to enjoy the vibrant culture and natural beauty that Wichita offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Botanica The Wichita Gardens",
      "seo_description": "Experience Aspen Park's apartments near Botanica The Wichita Gardens, KS. Enjoy lush surroundings and vibrant amenities in Wichita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "living-close-to-sedgwick-county-park-wichita",
      "search_query": "living close to Sedgwick County Park Wichita",
      "category": "Park",
      "h1_title": "Living Close to Sedgwick County Park",
      "h2_subtitle": "Aspen Park offers the best of both worlds with living close to Sedgwick County Park in Wichita, combining convenience with nature.",
      "page_copy": "Aspen Park is the ideal option for those looking into living close to Sedgwick County Park in Wichita. Situated nearby, our community allows residents to enjoy the natural beauty and recreational opportunities the park has to offer. Whether it's for a morning jog, a family picnic, or simply enjoying the great outdoors, Sedgwick County Park provides the perfect backdrop for a balanced lifestyle.\n\nAt Aspen Park, comfort and modern amenities align beautifully with this prime location. Residents can swiftly transition from the serenity of the park to the vibrant community features, including a sparkling pool and a fitness center. Choose Aspen Park if you want a comfortable home environment while still having access to Wichita’s cherished outdoor spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Sedgwick County Park, Wichita",
      "seo_description": "Aspen Park offers unique living close to Sedgwick County Park in Wichita. Enjoy nature and modern amenities seamlessly.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "wichita-apartments-by-pawnee-prairie-park",
      "search_query": "Wichita apartments by Pawnee Prairie Park",
      "category": "Park",
      "h1_title": "Wichita Apartments by Pawnee Prairie Park",
      "h2_subtitle": "Experience life at Aspen Park, Wichita's exceptional apartments located near the serene Pawnee Prairie Park.",
      "page_copy": "Aspen Park provides residents with exceptional Wichita apartments by Pawnee Prairie Park, blending natural surroundings with modern living. Located conveniently in Wichita, our community offers a unique residential experience that harmonizes with the stunning landscapes of Pawnee Prairie Park, perfect for outdoor enthusiasts who appreciate both tranquility and adventure.\n\nOur apartment community not only boasts close proximity to this gorgeous park but also offers a variety of amenities to enhance your lifestyle. From the inviting sundeck to the fully-equipped fitness center, every detail at Aspen Park is crafted for comfort and convenience. Choose our Wichita apartments by Pawnee Prairie Park and embrace a vibrant yet serene lifestyle that awaits you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wichita Apartments by Pawnee Prairie Park",
      "seo_description": "Explore Aspen Park's Wichita apartments, uniquely positioned by Pawnee Prairie Park. Enjoy nature and modern conveniences today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166543",
      "source": "generator",
      "page_item_url": "find-homes-near-central-riverside-park",
      "search_query": "find homes near Central Riverside Park Sedgwick County",
      "category": "Park",
      "h1_title": "Find Homes Near Central Riverside Park",
      "h2_subtitle": "Aspen Park offers the opportunity to find homes near Central Riverside Park, Sedgwick County, combining comfort with convenience.",
      "page_copy": "Discover Aspen Park, where you can find homes near Central Riverside Park in Sedgwick County. Located in a prime area of Wichita, our community offers easy access to the lush landscapes and recreational wonders of Central Riverside Park. Perfect for anyone wanting to balance urban living with serene outdoor spaces, Aspen Park is your ideal residence.\n\nOur community boasts a variety of amenities designed to enrich your lifestyle. Whether you're lounging by our refreshing pool or working out in our fitness center, enjoy all that Aspen Park has to offer. Living near Central Riverside Park means enjoying tranquil walks, picnics, and outdoor activities just a short drive away, making life both active and relaxed.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
      "featured_image_media": {
        "alt_text": "Aspen Park Apartments monument sign with landscaping.",
        "public_id": "019cfb4e-4117-7507-8479-d981da854e4e",
        "storage_key": "property/6767906449166543/019cfb4e-4117-7507-8479-d981da854e4e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Homes Near Central Riverside Park",
      "seo_description": "Discover Aspen Park homes near Central Riverside Park in Sedgwick County. Enjoy seamless access to nature and city life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5146"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-B50GNC6ZD2"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128850747"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/aspen-park/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NGC68W54"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449166543/019d1bb5-3fa4-70e6-a24a-fc765e0931a9.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "baeeec85-9d9b-4121-a284-83844e6f1bfc"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-254-2149"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "65008286fc5ed1b69dc2e4ac"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndRZkxIc3QyRmFHcGFtaVcvWS80aEE9PSIsInZhbHVlIjoiV3ZsQ2kvaGtpcXo2amZBcTBDWVBIUT09IiwibWFjIjoiNjRlZGNiNTM0OGQ0ZjlkZDMyMTkzZmZkZjE4ZWExOGViMDhiZjFhOGE5YjU4ZGNhYjBhZWNiNGVlMTM5NDYwYiJ9"
    }
  ],
  "custom_qb_id": "5146",
  "custom_ga4_id": "G-B50GNC6ZD2",
  "custom_repli_id": "18128850747",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/aspen-park/register/",
  "custom_google_gtm_id": "GTM-NGC68W54",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449166543/019d1bb5-3fa4-70e6-a24a-fc765e0931a9.pdf",
  "custom_rentgrata_property_id": "baeeec85-9d9b-4121-a284-83844e6f1bfc",
  "custom_ppc_tracking_phone_number": "866-254-2149",
  "custom_residentboost_apartment_id": "65008286fc5ed1b69dc2e4ac",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndRZkxIc3QyRmFHcGFtaVcvWS80aEE9PSIsInZhbHVlIjoiV3ZsQ2kvaGtpcXo2amZBcTBDWVBIUT09IiwibWFjIjoiNjRlZGNiNTM0OGQ0ZjlkZDMyMTkzZmZkZjE4ZWExOGViMDhiZjFhOGE5YjU4ZGNhYjBhZWNiNGVlMTM5NDYwYiJ9"
};

export const generatedAt = '2026-08-27T21:34:36.065Z';
